// Localization system for Gift-Wish

export const translations = {
  ru: {
    // General
    app_name: "Gift-Wish",
    free_for_all: "Бесплатно для всех",
    login: "Войти",
    logout: "Выйти",
    my_lists: "Мои списки",
    back: "← Назад",
    save: "Сохранить",
    cancel: "Отмена",
    delete: "Удалить",
    edit: "Редактировать",
    add: "Добавить",
    create: "Создать",
    share: "Поделиться",
    copied: "Скопировано!",
    loading: "Загрузка...",
    error: "Ошибка",
    success: "Успешно",
    too_many_requests: "Слишком много попыток. Попробуйте позже.",
    email_already_registered: "Этот email уже зарегистрирован",
    invalid_credentials: "Неверный email или пароль",
    password_too_short: "Пароль должен быть не менее 6 символов",
    
    // Landing
    hero_title: "Идеальные подарки",
    hero_title_accent: "без сюрпризов",
    hero_description: "Создайте список желаемых подарков и поделитесь им с друзьями. Они забронируют подарки — и никто не подарит одно и то же.",
    create_list: "Создать список",
    learn_more: "Узнать больше",
    how_it_works: "Как это работает",
    simple_process: "Простой процесс в 4 шага к идеальным подаркам",
    for_any_occasion: "Для любого события",
    not_only_birthday: "Создавайте списки не только для дня рождения",
    ready_to_create: "Готовы создать свой список?",
    join_free: "Присоединяйтесь бесплатно и начните получать идеальные подарки",
    start_free: "Создать список",
    all_rights: "Все права защищены.",
    privacy_policy: "Конфиденциальность",
    terms_of_service: "Условия",
    contact: "Контакты",
    
    // Features
    feature_gifts: "Списки подарков",
    feature_gifts_desc: "Создавайте списки для любых событий",
    feature_share: "Делитесь ссылкой",
    feature_share_desc: "Отправьте друзьям или в соцсети",
    feature_reserve: "Бронирование",
    feature_reserve_desc: "Друзья бронируют — никто не повторится",
    feature_countdown: "Обратный отсчёт",
    feature_countdown_desc: "Следите сколько дней до события",
    
    // Dashboard
    hello: "Привет",
    manage_wishlists: "Управляйте своими списками подарков",
    create_event: "Создать событие",
    no_events: "Пока нет событий",
    create_first: "Создайте своё первое событие!",
    upcoming_events: "Предстоящие события",
    past_events: "Прошедшие события",
    today: "Сегодня!",
    days: "дн.",
    
    // Event form
    new_event: "Новое событие",
    event_title: "Название",
    event_title_placeholder: "Мой День рождения 2026",
    event_type: "Тип события",
    event_date: "Дата события",
    currency: "Валюта",
    event_description: "Описание (необязательно)",
    event_description_placeholder: "Дополнительная информация...",
    public_list: "Публичный список",
    
    // Event types
    event_birthday: "День рождения",
    event_wedding: "Свадьба",
    event_new_year: "Новый год",
    event_baby_shower: "Baby Shower",
    event_graduation: "Выпускной",
    event_christmas: "Рождество",
    event_anniversary: "Годовщина",
    event_housewarming: "Новоселье",
    event_valentines: "День Святого Валентина",
    event_womens_day: "8 Марта",
    event_mothers_day: "День матери",
    event_fathers_day: "День отца",
    event_easter: "Пасха",
    event_halloween: "Хэллоуин",
    event_thanksgiving: "День благодарения",
    event_engagement: "Помолвка",
    event_retirement: "Выход на пенсию",
    event_promotion: "Повышение",
    event_other: "Другое",
    
    // Gifts
    gifts: "Подарки",
    add_gift: "Добавить подарок",
    edit_gift: "Редактировать",
    gift_name: "Название",
    gift_name_placeholder: "iPhone 15 Pro",
    gift_description: "Описание",
    gift_description_placeholder: "Цвет, размер и т.д.",
    gift_price: "Цена",
    gift_link: "Ссылка на товар",
    gift_image: "Изображение",
    auto_image_hint: "Или вставьте ссылку на товар — картинка загрузится автоматически",
    upload_image: "Загрузить изображение",
    upload_hint: "JPG, PNG, GIF до 5 МБ",
    drag_drop_hint: "Перетащите файл сюда или кликните",
    drop_here: "Отпустите для загрузки",
    uploading: "Загрузка...",
    image_uploaded: "Изображение загружено",
    upload_error: "Ошибка загрузки изображения",
    invalid_file_type: "Выберите изображение",
    file_too_large: "Максимум 5 МБ",
    image_error: "Ошибка загрузки",
    gift_priority: "Приоритет",
    priority_1: "Очень хочу",
    priority_2: "Хочу",
    priority_3: "Было бы неплохо",
    empty_list: "Список пуст",
    add_first_gift: "Добавьте первый подарок в список",
    reserved: "забронировано",
    reserved_by: "Забронировано:",
    link: "Ссылка",
    events_count: "событий",
    search_events: "Поиск событий...",
    search_users_placeholder: "Поиск по никнейму или номеру...",
    no_users_found: "Пользователи не найдены",
    search_hint: "Введите минимум 2 символа",
    days_left: "дней",
    past_event: "Прошедшее",
    today: "Сегодня",
    archived: "Архив",
    no_events: "Нет событий",
    create_first_event: "Создайте своё первое событие",
    
    // Archive
    archive: "Архив воспоминаний",
    save_as_memory: "Оставить на память",
    archived_events: "Архив событий",
    no_archived_events: "В архиве пусто",
    restore_event: "Восстановить",
    event_archived: "Событие перемещено в архив",
    event_restored: "Событие восстановлено",
    
    // Crowdfunding
    crowdfunding: "Складчина",
    enable_crowdfunding: "Включить складчину",
    goal_amount: "Целевая сумма",
    collected: "Собрано",
    contribute: "Скинуться",
    contribution_amount: "Сумма взноса",
    contribution_message: "Сообщение (необязательно)",
    contribution_hint: "Укажите сумму, которую вы готовы внести на этот подарок",
    message_placeholder: "С днём рождения!",
    contribution_success: "Взнос добавлен!",
    contributors: "Участники",
    no_contributions: "Пока никто не скинулся",
    crowdfunding_hint: "Друзья смогут скинуться на этот подарок",
    promised: "Обещано",
    view_contributions: "Взносы",
    contributions_list: "Список взносов",
    total: "Итого",
    
    // Public wishlist
    wishlist_from: "Список желаний от",
    in_days: "Через",
    reserved_gifts: "Забронировано подарков",
    of: "из",
    wishlist_not_found: "Список не найден",
    wrong_link: "Возможно, ссылка неверная или список приватный",
    
    // Reservation
    reserve_gift: "Забронировать подарок",
    reserve_description: "Укажите своё имя, чтобы другие знали что этот подарок уже забронирован",
    your_name: "Ваше имя",
    your_name_placeholder: "Как вас зовут?",
    reserve: "Забронировать",
    gift_reserved: "Подарок забронирован!",
    
    // Affiliate
    affiliate_note: "Покупая по этой ссылке, вы поддерживаете сервис",
    buy_now: "Купить",
    
    // Errors
    error_loading: "Ошибка загрузки",
    error_creating: "Ошибка создания",
    error_saving: "Ошибка сохранения",
    error_deleting: "Ошибка удаления",
    error_reserving: "Ошибка бронирования",
    error_auth: "Ошибка авторизации",
    fill_required: "Заполните обязательные поля",
    enter_name: "Введите ваше имя",
    enter_gift_name: "Введите название подарка",
    short_amazon_warning: "Короткие ссылки Amazon могут не работать с affiliate. Рекомендуем использовать полную ссылку на товар.",
    link_resolved: "Ссылка преобразована в полный формат",
    event_archived_message: "Это событие завершено и перемещено в архив",
    event_no_longer_available: "Список желаний больше недоступен",
    
    // Success
    event_created: "Событие создано!",
    event_updated: "Событие обновлено",
    event_deleted: "Событие удалено",
    delete_event_title: "Удалить мероприятие?",
    delete_event_confirm: "Это действие нельзя отменить. Все подарки в этом мероприятии также будут удалены.",
    edit_event: "Редактировать событие",
    enter_event_name: "Введите название события",
    gift_added: "Подарок добавлен",
    gift_updated: "Подарок обновлён",
    gift_deleted: "Подарок удалён",
    link_copied: "Ссылка скопирована!",
    
    
    // Admin
    admin_panel: "Админ-панель",
    admin_dashboard: "Дашборд",
    admin_users: "Пользователи",
    admin_events: "События",
    admin_clicks: "Клики",
    admin_export: "Экспорт",
    total_users: "Всего пользователей",
    total_events: "Всего событий",
    total_gifts: "Всего подарков",
    total_reservations: "Бронирований",
    total_clicks: "Кликов по ссылкам",
    new_last_30_days: "За 30 дней",
    clicks_by_type: "Клики по типу",
    daily_activity: "Активность по дням",
    top_products: "Топ товаров",
    search: "Поиск",
    actions: "Действия",
    ban: "Заблокировать",
    unban: "Разблокировать",
    banned: "Заблокирован",
    confirm_delete: "Подтвердите удаление",
    confirm_ban: "Подтвердите блокировку",
    user_banned: "Пользователь заблокирован",
    user_unbanned: "Пользователь разблокирован",
    user_deleted: "Пользователь удалён",
    export_csv: "Экспорт CSV",
    no_data: "Нет данных",
    clicks: "кликов",
    amazon: "Amazon",
    aliexpress: "AliExpress",
    ebay: "eBay",
    other: "Другое",
    
    // Auth Modal
    welcome_back: "С возвращением",
    create_account: "Создать аккаунт",
    login_subtitle: "Войдите чтобы продолжить",
    register_subtitle: "Присоединяйтесь бесплатно",
    continue_google: "Продолжить с Google",
    or: "или",
    name_placeholder: "Ваше имя",
    password: "Пароль",
    show_password: "Показать пароль",
    hide_password: "Скрыть пароль",
    sign_in: "Войти",
    sign_up: "Зарегистрироваться",
    no_account: "Нет аккаунта?",
    have_account: "Уже есть аккаунт?",
    email_required: "Введите email",
    email_invalid: "Неверный email",
    password_required: "Введите пароль",
    password_min: "Минимум 6 символов",
    name_required: "Введите имя",
    login_success: "Добро пожаловать!",
    register_success: "Аккаунт создан! Проверьте почту.",
    remember_me: "Запомнить меня",
    forgot_password: "Забыли пароль?",
    forgot_subtitle: "Введите email для восстановления",
    send_reset_link: "Отправить ссылку",
    check_email: "Проверьте почту",
    reset_email_sent: "Мы отправили ссылку для сброса пароля на",
    back_to_login: "Вернуться к входу",
    new_password: "Новый пароль",
    confirm_password: "Подтвердите пароль",
    reset_password: "Сбросить пароль",
    password_reset_success: "Пароль изменён! Теперь вы можете войти.",
    invalid_token: "Недействительная или просроченная ссылка",
    
    // Countdown timer
    countdown_days: "дней",
    countdown_hours: "часов",
    countdown_minutes: "минут",
    countdown_seconds: "секунд",
    event_passed: "Событие прошло",
    
    // Gift suggestions
    suggest_gift: "Предложить подарок",
    suggest_description: "Предложите идею подарка для этого списка",
    suggestion_sent: "Предложение отправлено!",
    pending_suggestions: "Предложения от друзей",
    no_suggestions: "Нет новых предложений",
    approve: "Добавить",
    reject: "Отклонить",
    suggestion_approved: "Предложение добавлено в список",
    suggestion_rejected: "Предложение отклонено",
    suggested_by: "Предложил(а):",
    
    // Reservation time
    reservation_time: "Время бронирования",
    reservation_expires_in: "Бронь истечёт через",
    reservation_permanent: "Бессрочное бронирование",
    reservation_expired: "Бронь истекла",
    bought: "Куплено",
    mark_bought: "Куплено",
    gift_bought: "Подарок куплен!",
    expires: "Истекает",
    show_more: "Показать больше",
    show_less: "Свернуть",
    gift_link_btn: "Ссылка на подарок",
    show_gift: "Показать подарок",
    show_timer_label: "Показывать таймер бронирования",
    show_timer_hint: "Друзья увидят оставшееся время брони",
    
    // PWA
    install_app: "Установить приложение",
    install_app_desc: "Добавьте Gift-Wish на главный экран для быстрого доступа",
    install: "Установить",
    not_now: "Не сейчас",
    
    // Telegram
    telegram_desc: "Получайте уведомления о бронированиях и взносах в Telegram",
    telegram_connected: "Подключено",
    telegram_notifications_desc: "Вы будете получать уведомления о бронированиях подарков, взносах в складчину и предложениях от друзей.",
    telegram_link_desc: "Нажмите кнопку ниже, чтобы открыть бота и привязать аккаунт:",
    telegram_code_expires: "Код действителен 10 минут",
    telegram_unlinked: "Telegram отключен",
    open_telegram: "Открыть Telegram",
    disconnect: "Отключить",
    
    // Navigation Sidebar
    nav_overview: "Обзор",
    nav_my_lists: "Мои списки",
    nav_groups: "Группы",
    nav_invitations: "Приглашения",
    nav_settings: "Настройки",
    sign_out: "Выйти",
    hide_menu: "Скрыть меню",
    show_menu: "Показать меню",
    your_code: "Ваш код",
    code_copied: "Код скопирован!",
    pending_invitations: "Ожидающие",
    no_pending_invitations: "Нет ожидающих приглашений",
    invited_by: "Пригласил",
    invitation_accepted: "Приглашение принято!",
    invitation_declined: "Приглашение отклонено",
    invitation_history: "История",
    accepted: "Принято",
    declined: "Отклонено",
    accept: "Принять",
    settings_saved: "Настройки сохранены",
    language_region: "Язык и регион",
    language_region_desc: "Выберите предпочитаемый язык и регион",
    notifications: "Уведомления",
    notifications_desc: "Управляйте способами получения уведомлений",
    email_event_reminders: "Напоминания о событиях",
    email_event_reminders_desc: "Получать напоминания перед событиями",
    email_gift_updates: "Обновления подарков",
    email_gift_updates_desc: "Когда подарки забронированы или куплены",
    email_invitations: "Уведомления о приглашениях",
    email_invitations_desc: "Когда вас приглашают на событие",
    
    // Notification settings - Categories
    notification_categories: "По категориям событий",
    notification_categories_desc: "Выберите, для каких событий получать email",
    notification_confirmations: "Email-подтверждения",
    notification_confirmations_desc: "Уведомления о действиях с вашими подарками",
    email_confirm_reservation: "Бронирование подарков",
    email_confirm_reservation_desc: "Когда кто-то бронирует ваш подарок",
    email_confirm_contribution: "Взносы в складчину",
    email_confirm_contribution_desc: "Когда кто-то вносит деньги в складчину",
    email_confirm_suggestion: "Предложения подарков",
    email_confirm_suggestion_desc: "Когда кто-то предлагает вам подарок",
    email_confirm_invitation: "Приглашения",
    email_confirm_invitation_desc: "Приглашения в группы и на события",
    email_confirm_reminder: "Напоминания",
    email_confirm_reminder_desc: "Напоминания о приближающихся событиях",
    push_notifications: "Push-уведомления",
    push_notifications_desc: "Уведомления в браузере и на телефоне",
    push_not_supported: "Не поддерживается",
    push_permission_granted: "Разрешение получено",
    push_permission_denied: "Разрешение отклонено",
    push_permission_required: "Требуется разрешение",
    push_browser_not_supported: "Браузер не поддерживает push-уведомления",
    push_active: "Активно",
    push_inactive: "Не активно",
    push_receive_notifications: "Получать уведомления",
    push_about_events: "О событиях, подарках и сообщениях",
    push_enabled_success: "Push-уведомления включены!",
    push_enable: "Включить уведомления",
    push_test: "Тест",
    push_disable: "Отключить",
    push_disabled_success: "Push-уведомления отключены",
    all_categories_on: "Включить все категории",
    all_categories_off: "Выключить все категории",
    
    privacy: "Конфиденциальность",
    privacy_desc: "Управляйте настройками конфиденциальности",
    public_profile: "Публичный профиль",
    public_profile_desc: "Другие могут видеть ваш профиль",
    show_wishlists: "Показывать списки желаний",
    show_wishlists_desc: "Отображать списки на вашем профиле",
    account: "Аккаунт",
    help_support: "Помощь и поддержка",
    coming_soon: "Скоро будет доступно",
    logged_out: "Вы вышли из аккаунта",
    create_group: "Создать группу",
    groups_coming_soon: "Группы скоро появятся",
    groups_coming_soon_desc: "Создавайте группы с друзьями и семьёй для координации подарков на особые события.",
    back_to_dashboard: "Вернуться к обзору",
    // Groups translations
    pending_invitations: "Ожидающие приглашения",
    my_groups: "Мои группы",
    no_groups: "Пока нет групп",
    no_groups_desc: "Создайте группу для координации подарков с друзьями и семьёй",
    create_first_group: "Создать первую группу",
    members: "участников",
    invite_members: "Пригласить участников",
    create_group_desc: "Создайте группу для координации подарков",
    group_name: "Название группы",
    group_name_placeholder: "например, Семейное Рождество",
    description: "Описание",
    group_desc_placeholder: "Для чего эта группа?",
    private_group: "Приватная группа",
    group_created: "Группа создана!",
    invitation_sent: "Приглашение отправлено!",
    by_username: "По имени",
    by_link: "По ссылке",
    search_username: "Поиск по имени или ID",
    or_enter_code: "Или введите код пользователя",
    invite: "Пригласить",
    share_link: "Поделитесь этой ссылкой",
    link_copied: "Ссылка скопирована!",
    link_desc: "Любой с этой ссылкой может запросить вступление в группу",
    qr_desc: "Отсканируйте QR-код чтобы присоединиться",
    from: "от",
    accept: "Принять",
    decline: "Отклонить",
    invitation_accepted: "Вы присоединились к группе!",
    invitation_declined: "Приглашение отклонено",
    leave_group: "Покинуть группу",
    delete_group: "Удалить группу",
    confirm_delete_group: "Вы уверены, что хотите удалить эту группу?",
    left_group: "Вы покинули группу",
    group_deleted: "Группа удалена",
    // Group advanced features
    transfer_ownership: "Передать владение",
    transfer_warning: "Это действие нельзя отменить. Новый владелец получит полный контроль над группой.",
    select_new_owner: "Выберите нового владельца",
    select_member: "Выберите участника",
    transfer: "Передать",
    ownership_transferred: "Владение передано!",
    share_event: "Поделиться событием",
    share_event_desc: "Поделитесь своим событием с этой группой",
    no_events_to_share: "У вас нет событий для публикации",
    event_shared: "Событие опубликовано в группе!",
    event_removed: "Событие удалено из группы",
    no_shared_events: "Нет опубликованных событий",
    shared_by: "опубликовал",
    view: "Открыть",
    owner: "Владелец",
    events: "События",
    chat: "Чат",
    type_message: "Введите сообщение...",
    no_messages: "Нет сообщений. Начните общение!",
    secret_santa: "Секретный Санта",
    santa_desc: "Организуйте обмен подарками внутри группы!",
    start_santa: "Запустить Секретного Санту",
    need_3_members: "Нужно минимум 3 участника для Секретного Санты",
    create_santa: "Создать Секретного Санту",
    santa_setup_desc: "Настройте обмен подарками для вашей группы",
    min_budget: "Мин. бюджет",
    max_budget: "Макс. бюджет",
    exchange_date: "Дата обмена",
    message: "Сообщение",
    santa_message_placeholder: "Добавьте особое сообщение для участников...",
    secret_santa_active: "Секретный Санта активен!",
    you_give_to: "Вы дарите подарок:",
    reveal: "Раскрыть всех",
    confirm_reveal: "Вы уверены, что хотите раскрыть Секретного Санту?",
    santa_revealed: "Секретный Санта раскрыт!",
    santa_cancelled: "Секретный Санта отменён",
    confirm_cancel_santa: "Вы уверены, что хотите отменить Секретного Санту?",
    confirm_leave: "Вы уверены, что хотите покинуть эту группу?",
    group_not_found: "Группа не найдена",
    premium: "Премиум",
    trusted_by: "Нам доверяют",
    happy_users: "довольных пользователей",
    no_duplicates: "Без дубликатов",
    smart_reservation: "Умное бронирование",
    open_list: "Открыть список",
    search_placeholder: "Поиск друзей или событий...",
    invitations: "Приглашения",
    my_events_section: "Мои события",
    see_all: "ВСЕ",
    view_gifts: "Смотреть подарки",
    gifts_progress: "подарков",
    no_invitations: "Нет приглашений",
    event_from: "от",
    // WebSocket chat
    connected: "Подключено",
    connecting: "Подключение...",
    typing: "печатает...",
    all_events_shared: "Все ваши события уже опубликованы в этой группе",
  },
  
  en: {
    app_name: "Gift-Wish",
    free_for_all: "Free for everyone",
    login: "Sign in",
    logout: "Sign out",
    my_lists: "My lists",
    back: "← Back",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    create: "Create",
    share: "Share",
    copied: "Copied!",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    too_many_requests: "Too many attempts. Please try again later.",
    email_already_registered: "This email is already registered",
    invalid_credentials: "Invalid email or password",
    password_too_short: "Password must be at least 6 characters",
    
    hero_title: "Perfect gifts",
    hero_title_accent: "no surprises",
    hero_description: "Create a wishlist and share it with friends. They'll reserve gifts — so no one gives the same thing twice.",
    create_list: "Create list",
    learn_more: "Learn more",
    how_it_works: "How it works",
    simple_process: "A simple 4-step process to perfect gifts",
    for_any_occasion: "For any occasion",
    not_only_birthday: "Create lists for more than just birthdays",
    ready_to_create: "Ready to create your list?",
    join_free: "Join for free and start receiving perfect gifts",
    start_free: "Create list",
    all_rights: "All rights reserved.",
    privacy_policy: "Privacy",
    terms_of_service: "Terms",
    contact: "Contact",
    
    feature_gifts: "Gift lists",
    feature_gifts_desc: "Create lists for any event",
    feature_share: "Share link",
    feature_share_desc: "Send to friends or social media",
    feature_reserve: "Reservation",
    feature_reserve_desc: "Friends reserve — no duplicates",
    feature_countdown: "Countdown",
    feature_countdown_desc: "Track days until the event",
    
    hello: "Hello",
    manage_wishlists: "Manage your wishlists",
    create_event: "Create event",
    no_events: "No events yet",
    create_first: "Create your first event!",
    upcoming_events: "Upcoming events",
    past_events: "Past events",
    today: "Today!",
    days: "days",
    
    new_event: "New event",
    event_title: "Title",
    event_title_placeholder: "My Birthday 2026",
    event_type: "Event type",
    event_date: "Event date",
    currency: "Currency",
    event_description: "Description (optional)",
    event_description_placeholder: "Additional information...",
    public_list: "Public list",
    
    event_birthday: "Birthday",
    event_wedding: "Wedding",
    event_new_year: "New Year",
    event_baby_shower: "Baby Shower",
    event_graduation: "Graduation",
    event_christmas: "Christmas",
    event_anniversary: "Anniversary",
    event_housewarming: "Housewarming",
    event_valentines: "Valentine's Day",
    event_womens_day: "Women's Day",
    event_mothers_day: "Mother's Day",
    event_fathers_day: "Father's Day",
    event_easter: "Easter",
    event_halloween: "Halloween",
    event_thanksgiving: "Thanksgiving",
    event_engagement: "Engagement",
    event_retirement: "Retirement",
    event_promotion: "Promotion",
    event_other: "Other",
    
    gifts: "Gifts",
    add_gift: "Add gift",
    edit_gift: "Edit",
    gift_name: "Name",
    gift_name_placeholder: "iPhone 15 Pro",
    gift_description: "Description",
    gift_description_placeholder: "Color, size, etc.",
    gift_price: "Price",
    gift_link: "Product link",
    gift_image: "Image",
    auto_image_hint: "Or paste product link — image will load automatically",
    upload_image: "Upload image",
    upload_hint: "JPG, PNG, GIF up to 5 MB",
    drag_drop_hint: "Drag & drop file here or click",
    drop_here: "Drop to upload",
    uploading: "Uploading...",
    image_uploaded: "Image uploaded",
    upload_error: "Upload error",
    invalid_file_type: "Select an image",
    file_too_large: "Maximum 5 MB",
    image_error: "Loading error",
    gift_priority: "Priority",
    priority_1: "Really want",
    priority_2: "Want",
    priority_3: "Nice to have",
    empty_list: "List is empty",
    add_first_gift: "Add your first gift to the list",
    reserved: "reserved",
    reserved_by: "Reserved by:",
    link: "Link",
    events_count: "events",
    search_events: "Search events...",
    search_users_placeholder: "Search by username or account number...",
    no_users_found: "No users found",
    search_hint: "Enter at least 2 characters",
    days_left: "days",
    past_event: "Past",
    today: "Today",
    archived: "Archived",
    no_events: "No events",
    create_first_event: "Create your first event",
    
    // Archive
    archive: "Memory Archive",
    save_as_memory: "Save as memory",
    archived_events: "Archived events",
    no_archived_events: "No archived events",
    restore_event: "Restore",
    event_archived: "Event archived",
    event_restored: "Event restored",
    
    // Crowdfunding
    crowdfunding: "Group buying",
    enable_crowdfunding: "Enable group buying",
    goal_amount: "Goal amount",
    collected: "Collected",
    contribute: "Contribute",
    contribution_amount: "Contribution amount",
    contribution_message: "Message (optional)",
    contribution_hint: "Enter the amount you would like to contribute for this gift",
    message_placeholder: "Happy birthday!",
    contribution_success: "Contribution added!",
    contributors: "Contributors",
    no_contributions: "No contributions yet",
    crowdfunding_hint: "Friends can chip in for this gift",
    promised: "Promised",
    view_contributions: "Contributions",
    contributions_list: "Contributions list",
    total: "Total",
    
    wishlist_from: "Wishlist from",
    in_days: "In",
    reserved_gifts: "Reserved gifts",
    of: "of",
    wishlist_not_found: "Wishlist not found",
    wrong_link: "The link may be wrong or the list is private",
    
    reserve_gift: "Reserve gift",
    reserve_description: "Enter your name so others know this gift is reserved",
    your_name: "Your name",
    your_name_placeholder: "What's your name?",
    reserve: "Reserve",
    gift_reserved: "Gift reserved!",
    
    affiliate_note: "By buying through this link, you support the service",
    buy_now: "Buy now",
    
    error_loading: "Loading error",
    error_creating: "Creation error",
    error_saving: "Saving error",
    error_deleting: "Deletion error",
    error_reserving: "Reservation error",
    error_auth: "Authentication error",
    fill_required: "Fill in required fields",
    enter_name: "Enter your name",
    enter_gift_name: "Enter gift name",
    event_archived_message: "This event has ended and been archived",
    event_no_longer_available: "This wishlist is no longer available",
    
    event_created: "Event created!",
    event_updated: "Event updated",
    event_deleted: "Event deleted",
    delete_event_title: "Delete event?",
    delete_event_confirm: "This action cannot be undone. All gifts in this event will also be deleted.",
    edit_event: "Edit event",
    enter_event_name: "Enter event name",
    gift_added: "Gift added",
    gift_updated: "Gift updated",
    gift_deleted: "Gift deleted",
    link_copied: "Link copied!",
    
    
    // Admin
    admin_panel: "Admin Panel",
    admin_dashboard: "Dashboard",
    admin_users: "Users",
    admin_events: "Events",
    admin_clicks: "Clicks",
    admin_export: "Export",
    total_users: "Total Users",
    total_events: "Total Events",
    total_gifts: "Total Gifts",
    total_reservations: "Reservations",
    total_clicks: "Link Clicks",
    new_last_30_days: "Last 30 days",
    clicks_by_type: "Clicks by Type",
    daily_activity: "Daily Activity",
    top_products: "Top Products",
    search: "Search",
    actions: "Actions",
    ban: "Ban",
    unban: "Unban",
    banned: "Banned",
    confirm_delete: "Confirm deletion",
    confirm_ban: "Confirm ban",
    user_banned: "User banned",
    user_unbanned: "User unbanned",
    user_deleted: "User deleted",
    export_csv: "Export CSV",
    no_data: "No data",
    clicks: "clicks",
    amazon: "Amazon",
    aliexpress: "AliExpress",
    ebay: "eBay",
    other: "Other",
    short_amazon_warning: "Short Amazon links may lose affiliate tracking. Please use full URL.",
    link_resolved: "Link resolved",
    
    // Password reset
    reset_password: "Reset Password",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    password_reset_success: "Password reset successfully!",
    invalid_token: "Invalid or expired token",
    
    // Auth Modal
    welcome_back: "Welcome back",
    create_account: "Create account",
    login_subtitle: "Sign in to continue",
    register_subtitle: "Join us for free",
    continue_google: "Continue with Google",
    or: "or",
    name_placeholder: "Your name",
    password: "Password",
    show_password: "Show password",
    hide_password: "Hide password",
    sign_in: "Sign in",
    sign_up: "Sign up",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    email_required: "Email required",
    email_invalid: "Invalid email",
    password_required: "Password required",
    password_min: "Min 6 characters",
    name_required: "Name required",
    login_success: "Welcome!",
    register_success: "Account created!",
    remember_me: "Remember me",
    forgot_password: "Forgot password?",
    forgot_subtitle: "Enter email to recover",
    send_reset_link: "Send link",
    check_email: "Check your email",
    reset_email_sent: "We sent a password reset link to",
    back_to_login: "Back to login",
    
    // Countdown timer
    countdown_days: "days",
    countdown_hours: "hours",
    countdown_minutes: "minutes",
    countdown_seconds: "seconds",
    event_passed: "Event passed",
    
    // Gift suggestions
    suggest_gift: "Suggest a gift",
    suggest_description: "Suggest a gift idea for this list",
    suggestion_sent: "Suggestion sent!",
    pending_suggestions: "Suggestions from friends",
    no_suggestions: "No new suggestions",
    approve: "Add",
    reject: "Reject",
    suggestion_approved: "Suggestion added to list",
    suggestion_rejected: "Suggestion rejected",
    suggested_by: "Suggested by:",
    
    // Reservation time
    reservation_time: "Reservation time",
    reservation_expires_in: "Expires in",
    reservation_permanent: "Permanent reservation",
    reservation_expired: "Reservation expired",
    bought: "Bought",
    mark_bought: "Bought",
    gift_bought: "Gift marked as bought!",
    expires: "Expires",
    show_more: "Show more",
    show_less: "Show less",
    gift_link_btn: "Gift link",
    show_gift: "Show gift",
    show_timer_label: "Show reservation timer",
    show_timer_hint: "Friends will see remaining time",
    
    // PWA
    install_app: "Install App",
    install_app_desc: "Add Gift-Wish to your home screen for quick access",
    install: "Install",
    not_now: "Not now",
    
    // Telegram
    telegram_desc: "Receive notifications about reservations and contributions in Telegram",
    telegram_connected: "Connected",
    telegram_notifications_desc: "You will receive notifications about gift reservations, crowdfunding contributions, and suggestions from friends.",
    telegram_link_desc: "Click the button below to open the bot and link your account:",
    telegram_code_expires: "Code valid for 10 minutes",
    telegram_unlinked: "Telegram disconnected",
    open_telegram: "Open Telegram",
    disconnect: "Disconnect",
    
    // Navigation Sidebar
    nav_overview: "Overview",
    nav_my_lists: "My Lists",
    nav_groups: "Groups",
    nav_invitations: "Invitations",
    nav_settings: "Settings",
    sign_out: "Sign Out",
    hide_menu: "Hide menu",
    show_menu: "Show menu",
    your_code: "Your code",
    code_copied: "Code copied!",
    pending_invitations: "Pending",
    no_pending_invitations: "No pending invitations",
    invited_by: "Invited by",
    invitation_accepted: "Invitation accepted!",
    invitation_declined: "Invitation declined",
    invitation_history: "History",
    accepted: "Accepted",
    declined: "Declined",
    accept: "Accept",
    settings_saved: "Settings saved",
    language_region: "Language & Region",
    language_region_desc: "Choose your preferred language and region",
    notifications: "Notifications",
    notifications_desc: "Manage how you receive notifications",
    email_event_reminders: "Event reminders",
    email_event_reminders_desc: "Receive reminders before events",
    email_gift_updates: "Gift updates",
    email_gift_updates_desc: "When gifts are reserved or purchased",
    email_invitations: "Invitation notifications",
    email_invitations_desc: "When someone invites you to an event",
    
    // Notification settings - Categories
    notification_categories: "By Event Categories",
    notification_categories_desc: "Choose which events to receive emails for",
    notification_confirmations: "Email Confirmations",
    notification_confirmations_desc: "Notifications about actions on your gifts",
    email_confirm_reservation: "Gift Reservations",
    email_confirm_reservation_desc: "When someone reserves your gift",
    email_confirm_contribution: "Crowdfunding Contributions",
    email_confirm_contribution_desc: "When someone contributes to your gift",
    email_confirm_suggestion: "Gift Suggestions",
    email_confirm_suggestion_desc: "When someone suggests a gift for you",
    email_confirm_invitation: "Invitations",
    email_confirm_invitation_desc: "Invitations to groups and events",
    email_confirm_reminder: "Reminders",
    email_confirm_reminder_desc: "Reminders about upcoming events",
    push_notifications: "Push Notifications",
    push_notifications_desc: "Browser and mobile notifications",
    push_not_supported: "Not supported",
    push_permission_granted: "Permission granted",
    push_permission_denied: "Permission denied",
    push_permission_required: "Permission required",
    push_browser_not_supported: "Browser does not support push notifications",
    push_active: "Active",
    push_inactive: "Inactive",
    push_receive_notifications: "Receive notifications",
    push_about_events: "About events, gifts, and messages",
    push_enabled_success: "Push notifications enabled!",
    push_enable: "Enable notifications",
    push_test: "Test",
    push_disable: "Disable",
    push_disabled_success: "Push notifications disabled",
    all_categories_on: "Enable all categories",
    all_categories_off: "Disable all categories",
    
    privacy: "Privacy",
    privacy_desc: "Control your privacy settings",
    public_profile: "Public profile",
    public_profile_desc: "Others can see your profile",
    show_wishlists: "Show wishlists",
    show_wishlists_desc: "Display wishlists on your profile",
    account: "Account",
    help_support: "Help & Support",
    coming_soon: "Coming soon",
    logged_out: "You have been logged out",
    create_group: "Create Group",
    groups_coming_soon: "Groups Coming Soon",
    groups_coming_soon_desc: "Create groups with friends and family to coordinate gift-giving for special occasions.",
    back_to_dashboard: "Back to Dashboard",
    // Groups translations
    pending_invitations: "Pending Invitations",
    my_groups: "My Groups",
    no_groups: "No groups yet",
    no_groups_desc: "Create a group to coordinate gifts with friends and family",
    create_first_group: "Create Your First Group",
    members: "members",
    invite_members: "Invite Members",
    create_group_desc: "Create a group to coordinate gifts with others",
    group_name: "Group Name",
    group_name_placeholder: "e.g., Family Christmas",
    description: "Description",
    group_desc_placeholder: "What's this group for?",
    private_group: "Private Group",
    group_created: "Group created!",
    invitation_sent: "Invitation sent!",
    by_username: "By Username",
    by_link: "By Link",
    search_username: "Search by username or ID",
    or_enter_code: "Or enter user code",
    invite: "Invite",
    share_link: "Share this link",
    link_copied: "Link copied!",
    link_desc: "Anyone with this link can request to join the group",
    qr_desc: "Scan this QR code to join the group",
    from: "from",
    accept: "Accept",
    decline: "Decline",
    invitation_accepted: "You joined the group!",
    invitation_declined: "Invitation declined",
    leave_group: "Leave Group",
    delete_group: "Delete Group",
    confirm_delete_group: "Are you sure you want to delete this group?",
    left_group: "You left the group",
    group_deleted: "Group deleted",
    // Group advanced features
    transfer_ownership: "Transfer Ownership",
    transfer_warning: "This action cannot be undone. The new owner will have full control over the group.",
    select_new_owner: "Select New Owner",
    select_member: "Select a member",
    transfer: "Transfer",
    ownership_transferred: "Ownership transferred!",
    share_event: "Share Event",
    share_event_desc: "Share one of your events with this group",
    no_events_to_share: "You don't have any events to share",
    event_shared: "Event shared with group!",
    event_removed: "Event removed from group",
    no_shared_events: "No shared events yet",
    shared_by: "shared by",
    view: "View",
    owner: "Owner",
    events: "Events",
    chat: "Chat",
    type_message: "Type a message...",
    no_messages: "No messages yet. Start the conversation!",
    secret_santa: "Secret Santa",
    santa_desc: "Organize a Secret Santa gift exchange within your group!",
    start_santa: "Start Secret Santa",
    need_3_members: "Need at least 3 members to start Secret Santa",
    create_santa: "Create Secret Santa",
    santa_setup_desc: "Set up a Secret Santa gift exchange for your group",
    min_budget: "Min Budget",
    max_budget: "Max Budget",
    exchange_date: "Exchange Date",
    message: "Message",
    santa_message_placeholder: "Add a special message for participants...",
    secret_santa_active: "Secret Santa is Active!",
    you_give_to: "You're giving a gift to:",
    reveal: "Reveal All",
    confirm_reveal: "Are you sure you want to reveal Secret Santa?",
    santa_revealed: "Secret Santa revealed!",
    santa_cancelled: "Secret Santa cancelled",
    confirm_cancel_santa: "Are you sure you want to cancel Secret Santa?",
    confirm_leave: "Are you sure you want to leave this group?",
    group_not_found: "Group not found",
    premium: "Premium",
    trusted_by: "Trusted by thousands",
    happy_users: "of happy users",
    no_duplicates: "No duplicates",
    smart_reservation: "Smart reservation",
    open_list: "Open Wishlist",
    search_placeholder: "Search friends or events...",
    invitations: "Invitations",
    my_events_section: "My Events",
    see_all: "ALL",
    view_gifts: "View Gifts",
    gifts_progress: "gifts",
    no_invitations: "No invitations",
    event_from: "from",
    // WebSocket chat
    connected: "Connected",
    connecting: "Connecting...",
    typing: "typing...",
    all_events_shared: "All your events are already shared with this group",
  },
  
  es: {
    app_name: "Gift-Wish",
    reservation_time: "Hora de reserva",
    free_for_all: "Gratis para todos",
    login: "Iniciar sesión",
    logout: "Cerrar sesión",
    my_lists: "Mis listas",
    back: "← Volver",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    add: "Añadir",
    create: "Crear",
    share: "Compartir",
    copied: "¡Copiado!",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    too_many_requests: "Demasiados intentos. Inténtalo más tarde.",
    email_already_registered: "Este correo ya está registrado",
    invalid_credentials: "Correo o contraseña inválidos",
    password_too_short: "La contraseña debe tener al menos 6 caracteres",
    
    hero_title: "Regalos perfectos",
    hero_title_accent: "sin sorpresas",
    hero_description: "Crea una lista de deseos y compártela con amigos. Ellos reservarán regalos — para que nadie regale lo mismo.",
    create_list: "Crear lista",
    learn_more: "Saber más",
    how_it_works: "Cómo funciona",
    simple_process: "Un proceso simple de 4 pasos para regalos perfectos",
    for_any_occasion: "Para cualquier ocasión",
    not_only_birthday: "Crea listas para más que solo cumpleaños",
    ready_to_create: "¿Listo para crear tu lista?",
    join_free: "Únete gratis y comienza a recibir regalos perfectos",
    start_free: "Empezar gratis",
    all_rights: "Todos los derechos reservados.",
    privacy_policy: "Privacidad",
    terms_of_service: "Términos",
    contact: "Contacto",
    
    feature_gifts: "Listas de regalos",
    feature_gifts_desc: "Crea listas para cualquier evento",
    feature_share: "Comparte enlace",
    feature_share_desc: "Envía a amigos o redes sociales",
    feature_reserve: "Reserva",
    feature_reserve_desc: "Amigos reservan — sin duplicados",
    feature_countdown: "Cuenta regresiva",
    feature_countdown_desc: "Sigue los días hasta el evento",
    
    hello: "Hola",
    manage_wishlists: "Gestiona tus listas de deseos",
    create_event: "Crear evento",
    no_events: "Aún no hay eventos",
    create_first: "¡Crea tu primer evento!",
    upcoming_events: "Próximos eventos",
    past_events: "Eventos pasados",
    today: "¡Hoy!",
    days: "días",
    
    new_event: "Nuevo evento",
    event_title: "Título",
    event_title_placeholder: "Mi Cumpleaños 2026",
    event_type: "Tipo de evento",
    event_date: "Fecha del evento",
    currency: "Moneda",
    event_description: "Descripción (opcional)",
    event_description_placeholder: "Información adicional...",
    public_list: "Lista pública",
    
    event_birthday: "Cumpleaños",
    event_wedding: "Boda",
    event_new_year: "Año Nuevo",
    event_baby_shower: "Baby Shower",
    event_graduation: "Graduación",
    event_christmas: "Navidad",
    event_anniversary: "Aniversario",
    event_housewarming: "Inauguración de casa",
    event_valentines: "San Valentín",
    event_womens_day: "Día de la Mujer",
    event_mothers_day: "Día de la Madre",
    event_fathers_day: "Día del Padre",
    event_easter: "Pascua",
    event_halloween: "Halloween",
    event_thanksgiving: "Acción de Gracias",
    event_engagement: "Compromiso",
    event_retirement: "Jubilación",
    event_promotion: "Ascenso",
    event_other: "Otro",
    
    gifts: "Regalos",
    add_gift: "Añadir regalo",
    edit_gift: "Editar",
    gift_name: "Nombre",
    gift_name_placeholder: "iPhone 15 Pro",
    gift_description: "Descripción",
    gift_description_placeholder: "Color, tamaño, etc.",
    gift_price: "Precio",
    gift_link: "Enlace del producto",
    gift_image: "Imagen",
    auto_image_hint: "O pega el enlace del producto — la imagen se cargará automáticamente",
    upload_image: "Subir imagen",
    upload_hint: "JPG, PNG, GIF hasta 5 MB",
    drag_drop_hint: "Arrastra y suelta aquí o haz clic",
    drop_here: "Suelta para subir",
    uploading: "Subiendo...",
    image_uploaded: "Imagen subida",
    upload_error: "Error al subir",
    invalid_file_type: "Selecciona una imagen",
    file_too_large: "Máximo 5 MB",
    image_error: "Error de carga",
    gift_priority: "Prioridad",
    priority_1: "Lo quiero mucho",
    priority_2: "Lo quiero",
    priority_3: "Estaría bien",
    empty_list: "Lista vacía",
    add_first_gift: "Añade tu primer regalo a la lista",
    reserved: "reservado",
    reserved_by: "Reservado por:",
    link: "Enlace",
    events_count: "eventos",
    search_events: "Buscar eventos...",
    search_users_placeholder: "Buscar por usuario o número...",
    no_users_found: "No se encontraron usuarios",
    search_hint: "Ingresa al menos 2 caracteres",
    days_left: "días",
    past_event: "Pasado",
    today: "Hoy",
    archived: "Archivado",
    no_events: "Sin eventos",
    create_first_event: "Crea tu primer evento",
    
    // Archive
    archive: "Archivo de recuerdos",
    save_as_memory: "Guardar como recuerdo",
    archived_events: "Eventos archivados",
    no_archived_events: "No hay eventos archivados",
    restore_event: "Restaurar",
    event_archived: "Evento archivado",
    event_restored: "Evento restaurado",
    
    // Crowdfunding
    crowdfunding: "Vaquita",
    enable_crowdfunding: "Habilitar vaquita",
    goal_amount: "Monto objetivo",
    collected: "Recaudado",
    contribute: "Contribuir",
    contribution_amount: "Monto de contribución",
    contribution_message: "Mensaje (opcional)",
    contribution_hint: "Ingrese el monto que desea contribuir para este regalo",
    message_placeholder: "¡Feliz cumpleaños!",
    contribution_success: "¡Contribución añadida!",
    contributors: "Contribuidores",
    no_contributions: "Sin contribuciones aún",
    crowdfunding_hint: "Los amigos pueden contribuir para este regalo",
    promised: "Prometido",
    view_contributions: "Contribuciones",
    contributions_list: "Lista de contribuciones",
    total: "Total",
    
    wishlist_from: "Lista de deseos de",
    in_days: "En",
    reserved_gifts: "Regalos reservados",
    of: "de",
    wishlist_not_found: "Lista no encontrada",
    wrong_link: "El enlace puede ser incorrecto o la lista es privada",
    
    reserve_gift: "Reservar regalo",
    reserve_description: "Ingresa tu nombre para que otros sepan que este regalo está reservado",
    your_name: "Tu nombre",
    your_name_placeholder: "¿Cómo te llamas?",
    reserve: "Reservar",
    gift_reserved: "¡Regalo reservado!",
    
    affiliate_note: "Comprando a través de este enlace, apoyas el servicio",
    buy_now: "Comprar",
    
    error_loading: "Error de carga",
    error_creating: "Error de creación",
    error_saving: "Error al guardar",
    error_deleting: "Error al eliminar",
    error_reserving: "Error de reserva",
    error_auth: "Error de autenticación",
    fill_required: "Completa los campos requeridos",
    enter_name: "Ingresa tu nombre",
    enter_gift_name: "Ingresa el nombre del regalo",
    event_archived_message: "Este evento ha terminado y fue archivado",
    event_no_longer_available: "Esta lista de deseos ya no está disponible",
    
    event_created: "¡Evento creado!",
    event_updated: "Evento actualizado",
    event_deleted: "Evento eliminado",
    delete_event_title: "¿Eliminar evento?",
    delete_event_confirm: "Esta acción no se puede deshacer. Todos los regalos de este evento también serán eliminados.",
    edit_event: "Editar evento",
    enter_event_name: "Ingresa el nombre del evento",
    gift_added: "Regalo añadido",
    gift_updated: "Regalo actualizado",
    gift_deleted: "Regalo eliminado",
    link_copied: "¡Enlace copiado!",
    
    
    // Admin
    admin_panel: "Panel de administración",
    new_last_30_days: "Últimos 30 días",
    
    // Auth Modal
    welcome_back: "Bienvenido de nuevo",
    create_account: "Crear cuenta",
    login_subtitle: "Inicia sesión para continuar",
    register_subtitle: "Únete gratis",
    continue_google: "Continuar con Google",
    or: "o",
    name_placeholder: "Tu nombre",
    password: "Contraseña",
    show_password: "Mostrar contraseña",
    hide_password: "Ocultar contraseña",
    sign_in: "Iniciar sesión",
    sign_up: "Registrarse",
    no_account: "¿No tienes cuenta?",
    have_account: "¿Ya tienes cuenta?",
    email_required: "Email requerido",
    email_invalid: "Email inválido",
    password_required: "Contraseña requerida",
    password_min: "Mínimo 6 caracteres",
    name_required: "Nombre requerido",
    login_success: "¡Bienvenido!",
    register_success: "¡Cuenta creada!",
    remember_me: "Recordarme",
    forgot_password: "¿Olvidaste tu contraseña?",
    forgot_subtitle: "Ingresa email para recuperar",
    send_reset_link: "Enviar enlace",
    check_email: "Revisa tu email",
    reset_email_sent: "Enviamos un enlace para restablecer la contraseña a",
    back_to_login: "Volver a iniciar sesión",
    
    // Countdown
    countdown_days: "días",
    countdown_hours: "horas",
    countdown_minutes: "minutos",
    countdown_seconds: "segundos",
    event_passed: "Evento pasado",
    
    // Gift link
    gift_link_btn: "Enlace al regalo",
    show_gift: "Ver regalo",
    
    // Reservation
    expires: "Caduca",
    reservation_expired: "Reserva caducada",
    reservation_permanent: "Reserva permanente",
    reservation_expires_in: "Caduca en",
    show_more: "Ver más",
    show_less: "Ver menos",
    bought: "Comprado",
    mark_bought: "Comprado",
    gift_bought: "¡Regalo marcado como comprado!",
    show_timer_label: "Mostrar temporizador de reserva",
    show_timer_hint: "Los amigos verán el tiempo restante",
    
    // Suggestions
    suggest_gift: "Sugerir regalo",
    suggest_description: "Sugiere una idea de regalo para esta lista",
    suggestion_sent: "¡Sugerencia enviada!",
    pending_suggestions: "Sugerencias de amigos",
    no_suggestions: "No hay nuevas sugerencias",
    approve: "Agregar",
    reject: "Rechazar",
    suggestion_approved: "Sugerencia añadida a la lista",
    suggestion_rejected: "Sugerencia rechazada",
    suggested_by: "Sugerido por:",
    
    // Telegram
    telegram_desc: "Recibe notificaciones sobre reservas y contribuciones en Telegram",
    telegram_connected: "Conectado",
    telegram_notifications_desc: "Recibirás notificaciones sobre reservas de regalos, contribuciones de vaquita y sugerencias de amigos.",
    telegram_link_desc: "Haz clic en el botón de abajo para abrir el bot y vincular tu cuenta:",
    telegram_code_expires: "Código válido por 10 minutos",
    telegram_unlinked: "Telegram desconectado",
    open_telegram: "Abrir Telegram",
    disconnect: "Desconectar",
    
    // PWA
    install_app: "Instalar aplicación",
    install_app_desc: "Agrega Gift-Wish a tu pantalla de inicio para acceso rápido",
    install: "Instalar",
    not_now: "Ahora no",
    
    // Password reset
    reset_password: "Restablecer contraseña",
    new_password: "Nueva contraseña",
    confirm_password: "Confirmar contraseña",
    password_reset_success: "¡Contraseña restablecida!",
    invalid_token: "Token inválido o expirado",
    
    // Admin panel
    admin_dashboard: "Panel",
    admin_users: "Usuarios",
    admin_events: "Eventos",
    admin_clicks: "Clics de afiliados",
    admin_export: "Exportar datos",
    search: "Buscar...",
    actions: "Acciones",
    ban: "Bloquear",
    unban: "Desbloquear",
    banned: "Bloqueado",
    confirm_ban: "¿Seguro que quieres bloquear este usuario?",
    confirm_delete: "¿Seguro que quieres eliminar?",
    user_banned: "Usuario bloqueado",
    user_unbanned: "Usuario desbloqueado",
    user_deleted: "Usuario eliminado",
    export_csv: "Exportar CSV",
    no_data: "Sin datos",
    total_users: "Total usuarios",
    total_events: "Total eventos",
    total_gifts: "Total regalos",
    total_reservations: "Total reservas",
    total_clicks: "Total clics",
    daily_activity: "Actividad diaria",
    top_products: "Productos populares",
    clicks_by_type: "Clics por tipo",
    clicks: "Clics",
    
    // Affiliate
    amazon: "Amazon",
    aliexpress: "AliExpress",
    ebay: "eBay",
    other: "Otro",
    short_amazon_warning: "Los enlaces cortos de Amazon pueden perder seguimiento. Usa la URL completa.",
    link_resolved: "Enlace resuelto",
    
    // Navigation Sidebar
    nav_overview: "Resumen",
    nav_my_lists: "Mis listas",
    nav_groups: "Grupos",
    nav_invitations: "Invitaciones",
    nav_settings: "Ajustes",
    sign_out: "Cerrar sesión",
    hide_menu: "Ocultar menú",
    show_menu: "Mostrar menú",
    your_code: "Tu código",
    code_copied: "¡Código copiado!",
    pending_invitations: "Pendientes",
    no_pending_invitations: "No hay invitaciones pendientes",
    invited_by: "Invitado por",
    invitation_accepted: "¡Invitación aceptada!",
    invitation_declined: "Invitación rechazada",
    invitation_history: "Historial",
    accepted: "Aceptado",
    declined: "Rechazado",
    accept: "Aceptar",
    settings_saved: "Configuración guardada",
    language_region: "Idioma y región",
    language_region_desc: "Elige tu idioma y región preferidos",
    notifications: "Notificaciones",
    notifications_desc: "Administra cómo recibes notificaciones",
    email_event_reminders: "Recordatorios de eventos",
    email_event_reminders_desc: "Recibir recordatorios antes de eventos",
    email_gift_updates: "Actualizaciones de regalos",
    email_gift_updates_desc: "Cuando se reservan o compran regalos",
    email_invitations: "Notificaciones de invitación",
    email_invitations_desc: "Cuando alguien te invita a un evento",
    
    // Notification settings - Categories
    notification_categories: "Por categorías de eventos",
    notification_categories_desc: "Elige para qué eventos recibir emails",
    notification_confirmations: "Confirmaciones por email",
    notification_confirmations_desc: "Notificaciones sobre acciones en tus regalos",
    email_confirm_reservation: "Reservas de regalos",
    email_confirm_reservation_desc: "Cuando alguien reserva tu regalo",
    email_confirm_contribution: "Contribuciones grupales",
    email_confirm_contribution_desc: "Cuando alguien contribuye a tu regalo",
    email_confirm_suggestion: "Sugerencias de regalos",
    email_confirm_suggestion_desc: "Cuando alguien te sugiere un regalo",
    email_confirm_invitation: "Invitaciones",
    email_confirm_invitation_desc: "Invitaciones a grupos y eventos",
    email_confirm_reminder: "Recordatorios",
    email_confirm_reminder_desc: "Recordatorios de eventos próximos",
    push_notifications: "Notificaciones push",
    push_notifications_desc: "Notificaciones en navegador y móvil",
    push_not_supported: "No soportado",
    push_permission_granted: "Permiso concedido",
    push_permission_denied: "Permiso denegado",
    push_permission_required: "Permiso requerido",
    push_browser_not_supported: "El navegador no soporta notificaciones push",
    push_active: "Activo",
    push_inactive: "Inactivo",
    push_receive_notifications: "Recibir notificaciones",
    push_about_events: "Sobre eventos, regalos y mensajes",
    push_enabled_success: "¡Notificaciones push activadas!",
    push_enable: "Activar notificaciones",
    push_test: "Probar",
    push_disable: "Desactivar",
    push_disabled_success: "Notificaciones push desactivadas",
    all_categories_on: "Activar todas",
    all_categories_off: "Desactivar todas",
    
    privacy: "Privacidad",
    privacy_desc: "Controla tu configuración de privacidad",
    public_profile: "Perfil público",
    public_profile_desc: "Otros pueden ver tu perfil",
    show_wishlists: "Mostrar listas de deseos",
    show_wishlists_desc: "Mostrar listas en tu perfil",
    account: "Cuenta",
    help_support: "Ayuda y soporte",
    coming_soon: "Próximamente",
    logged_out: "Has cerrado sesión",
    premium: "Premium",
    trusted_by: "Miles confían",
    happy_users: "en nosotros",
    no_duplicates: "Sin duplicados",
    smart_reservation: "Reserva inteligente",
    open_list: "Abrir lista",
    search_placeholder: "Buscar amigos o eventos...",
    invitations: "Invitaciones",
    my_events_section: "Mis Eventos",
    see_all: "VER TODO",
    view_gifts: "Ver regalos",
    gifts_progress: "regalos",
    no_invitations: "Sin invitaciones",
    event_from: "de",
    
    // Groups - Missing translations
    create_group: "Crear grupo",
    groups_coming_soon: "Grupos próximamente",
    groups_coming_soon_desc: "Crea grupos con amigos y familia para coordinar regalos.",
    back_to_dashboard: "Volver al panel",
    my_groups: "Mis grupos",
    no_groups: "Sin grupos aún",
    no_groups_desc: "Crea un grupo para coordinar regalos",
    create_first_group: "Crear primer grupo",
    members: "miembros",
    invite_members: "Invitar miembros",
    create_group_desc: "Crea un grupo para coordinar regalos",
    group_name: "Nombre del grupo",
    group_name_placeholder: "Ej: Navidad familiar",
    description: "Descripción",
    group_desc_placeholder: "¿Para qué es este grupo?",
    private_group: "Grupo privado",
    group_created: "¡Grupo creado!",
    invitation_sent: "¡Invitación enviada!",
    by_username: "Por nombre de usuario",
    by_link: "Por enlace",
    search_username: "Buscar por usuario o ID",
    or_enter_code: "O introduce el código",
    invite: "Invitar",
    share_link: "Compartir enlace",
    link_desc: "Cualquiera con este enlace puede unirse",
    qr_desc: "Escanea para unirte al grupo",
    owner: "Propietario",
    leave_group: "Abandonar grupo",
    delete_group: "Eliminar grupo",
    left_group: "Has abandonado el grupo",
    group_deleted: "Grupo eliminado",
    confirm_leave: "¿Seguro que quieres abandonar este grupo?",
    confirm_delete_group: "¿Seguro que quieres eliminar este grupo?",
    group_not_found: "Grupo no encontrado",
    decline: "Rechazar",
    from: "de",
    view: "Ver",
    
    // Group tabs
    events: "Eventos",
    chat: "Chat",
    secret_santa: "Santa Secreto",
    
    // Group events
    share_event: "Compartir evento",
    share_event_desc: "Comparte tu evento con este grupo",
    no_shared_events: "Sin eventos compartidos",
    no_events_to_share: "No tienes eventos para compartir",
    all_events_shared: "Todos tus eventos ya están compartidos",
    event_shared: "¡Evento compartido!",
    event_removed: "Evento eliminado del grupo",
    shared_by: "Compartido por",
    
    // Group chat
    type_message: "Escribe un mensaje...",
    message: "Mensaje",
    no_messages: "Sin mensajes aún",
    connected: "Conectado",
    connecting: "Conectando...",
    typing: "escribiendo...",
    
    // Secret Santa
    create_santa: "Crear Santa Secreto",
    santa_desc: "Organiza un intercambio de regalos secreto",
    santa_setup_desc: "Configura el presupuesto y fecha",
    min_budget: "Presupuesto mínimo",
    max_budget: "Presupuesto máximo",
    exchange_date: "Fecha de intercambio",
    santa_message_placeholder: "Mensaje opcional para participantes...",
    start_santa: "Iniciar sorteo",
    need_3_members: "Se necesitan al menos 3 miembros",
    secret_santa_active: "¡Santa Secreto activo!",
    you_give_to: "Tú regalas a",
    reveal: "Revelar",
    confirm_reveal: "¿Revelar todos los emparejamientos?",
    santa_revealed: "¡Santa Secreto revelado!",
    santa_cancelled: "Santa Secreto cancelado",
    confirm_cancel_santa: "¿Cancelar Santa Secreto?",
    
    // Transfer ownership
    transfer_ownership: "Transferir propiedad",
    select_new_owner: "Seleccionar nuevo propietario",
    select_member: "Seleccionar miembro",
    transfer: "Transferir",
    transfer_warning: "Esta acción no se puede deshacer",
    ownership_transferred: "Propiedad transferida",
  },
  
  fr: {
    app_name: "Gift-Wish",
    reservation_time: "Heure de réservation",
    free_for_all: "Gratuit pour tous",
    login: "Se connecter",
    logout: "Se déconnecter",
    my_lists: "Mes listes",
    back: "← Retour",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    add: "Ajouter",
    create: "Créer",
    share: "Partager",
    copied: "Copié !",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    too_many_requests: "Trop de tentatives. Réessayez plus tard.",
    email_already_registered: "Cet email est déjà enregistré",
    invalid_credentials: "Email ou mot de passe invalide",
    password_too_short: "Le mot de passe doit contenir au moins 6 caractères",
    
    hero_title: "Des cadeaux parfaits",
    hero_title_accent: "sans surprises",
    hero_description: "Créez une liste de souhaits et partagez-la avec vos amis. Ils réserveront les cadeaux — personne n'offrira la même chose.",
    create_list: "Créer une liste",
    learn_more: "En savoir plus",
    how_it_works: "Comment ça marche",
    simple_process: "Un processus simple en 4 étapes pour des cadeaux parfaits",
    for_any_occasion: "Pour toute occasion",
    not_only_birthday: "Créez des listes pour plus que des anniversaires",
    ready_to_create: "Prêt à créer votre liste ?",
    join_free: "Rejoignez gratuitement et recevez des cadeaux parfaits",
    start_free: "Commencer gratuitement",
    all_rights: "Tous droits réservés.",
    privacy_policy: "Confidentialité",
    terms_of_service: "Conditions",
    contact: "Contact",
    
    feature_gifts: "Listes de cadeaux",
    feature_gifts_desc: "Créez des listes pour tout événement",
    feature_share: "Partagez le lien",
    feature_share_desc: "Envoyez aux amis ou réseaux sociaux",
    feature_reserve: "Réservation",
    feature_reserve_desc: "Les amis réservent — pas de doublons",
    feature_countdown: "Compte à rebours",
    feature_countdown_desc: "Suivez les jours jusqu'à l'événement",
    
    hello: "Bonjour",
    manage_wishlists: "Gérez vos listes de souhaits",
    create_event: "Créer un événement",
    no_events: "Pas encore d'événements",
    create_first: "Créez votre premier événement !",
    upcoming_events: "Événements à venir",
    past_events: "Événements passés",
    today: "Aujourd'hui !",
    days: "jours",
    
    new_event: "Nouvel événement",
    event_title: "Titre",
    event_title_placeholder: "Mon Anniversaire 2026",
    event_type: "Type d'événement",
    event_date: "Date de l'événement",
    currency: "Devise",
    event_description: "Description (optionnel)",
    event_description_placeholder: "Informations supplémentaires...",
    public_list: "Liste publique",
    
    event_birthday: "Anniversaire",
    event_wedding: "Mariage",
    event_new_year: "Nouvel An",
    event_baby_shower: "Baby Shower",
    event_graduation: "Diplôme",
    event_christmas: "Noël",
    event_anniversary: "Anniversaire de mariage",
    event_housewarming: "Pendaison de crémaillère",
    event_valentines: "Saint-Valentin",
    event_womens_day: "Journée de la Femme",
    event_mothers_day: "Fête des Mères",
    event_fathers_day: "Fête des Pères",
    event_easter: "Pâques",
    event_halloween: "Halloween",
    event_thanksgiving: "Thanksgiving",
    event_engagement: "Fiançailles",
    event_retirement: "Retraite",
    event_promotion: "Promotion",
    event_other: "Autre",
    
    gifts: "Cadeaux",
    add_gift: "Ajouter un cadeau",
    edit_gift: "Modifier",
    gift_name: "Nom",
    gift_name_placeholder: "iPhone 15 Pro",
    gift_description: "Description",
    gift_description_placeholder: "Couleur, taille, etc.",
    gift_price: "Prix",
    gift_link: "Lien du produit",
    gift_image: "Image",
    auto_image_hint: "Ou collez le lien du produit — l'image se chargera automatiquement",
    upload_image: "Télécharger l'image",
    upload_hint: "JPG, PNG, GIF jusqu'à 5 Mo",
    drag_drop_hint: "Glissez-déposez ici ou cliquez",
    drop_here: "Déposez pour télécharger",
    uploading: "Téléchargement...",
    image_uploaded: "Image téléchargée",
    upload_error: "Erreur de téléchargement",
    invalid_file_type: "Sélectionnez une image",
    file_too_large: "Maximum 5 Mo",
    image_error: "Erreur de chargement",
    gift_priority: "Priorité",
    priority_1: "Je veux vraiment",
    priority_2: "Je veux",
    priority_3: "Ce serait bien",
    empty_list: "Liste vide",
    add_first_gift: "Ajoutez votre premier cadeau à la liste",
    reserved: "réservé",
    reserved_by: "Réservé par :",
    link: "Lien",
    events_count: "événements",
    search_events: "Rechercher des événements...",
    search_users_placeholder: "Rechercher par pseudo ou numéro...",
    no_users_found: "Aucun utilisateur trouvé",
    search_hint: "Entrez au moins 2 caractères",
    days_left: "jours",
    past_event: "Passé",
    today: "Aujourd'hui",
    archived: "Archivé",
    no_events: "Aucun événement",
    create_first_event: "Créez votre premier événement",
    
    // Archive
    archive: "Archives souvenirs",
    save_as_memory: "Garder en souvenir",
    archived_events: "Événements archivés",
    no_archived_events: "Pas d'événements archivés",
    restore_event: "Restaurer",
    event_archived: "Événement archivé",
    event_restored: "Événement restauré",
    
    // Crowdfunding
    crowdfunding: "Cagnotte",
    enable_crowdfunding: "Activer la cagnotte",
    goal_amount: "Montant objectif",
    collected: "Collecté",
    contribute: "Contribuer",
    contribution_amount: "Montant de la contribution",
    contribution_message: "Message (facultatif)",
    contribution_hint: "Indiquez le montant que vous souhaitez contribuer pour ce cadeau",
    message_placeholder: "Joyeux anniversaire !",
    contribution_success: "Contribution ajoutée !",
    contributors: "Contributeurs",
    no_contributions: "Pas encore de contributions",
    crowdfunding_hint: "Les amis peuvent contribuer pour ce cadeau",
    promised: "Promis",
    view_contributions: "Contributions",
    contributions_list: "Liste des contributions",
    total: "Total",
    
    wishlist_from: "Liste de souhaits de",
    in_days: "Dans",
    reserved_gifts: "Cadeaux réservés",
    of: "sur",
    wishlist_not_found: "Liste non trouvée",
    wrong_link: "Le lien est peut-être incorrect ou la liste est privée",
    
    reserve_gift: "Réserver le cadeau",
    reserve_description: "Entrez votre nom pour que les autres sachent que ce cadeau est réservé",
    your_name: "Votre nom",
    your_name_placeholder: "Comment vous appelez-vous ?",
    reserve: "Réserver",
    gift_reserved: "Cadeau réservé !",
    
    affiliate_note: "En achetant via ce lien, vous soutenez le service",
    buy_now: "Acheter",
    
    error_loading: "Erreur de chargement",
    error_creating: "Erreur de création",
    error_saving: "Erreur de sauvegarde",
    error_deleting: "Erreur de suppression",
    error_reserving: "Erreur de réservation",
    error_auth: "Erreur d'authentification",
    fill_required: "Remplissez les champs requis",
    enter_name: "Entrez votre nom",
    enter_gift_name: "Entrez le nom du cadeau",
    event_archived_message: "Cet événement est terminé et a été archivé",
    event_no_longer_available: "Cette liste de souhaits n'est plus disponible",
    
    event_created: "Événement créé !",
    event_updated: "Événement mis à jour",
    event_deleted: "Événement supprimé",
    delete_event_title: "Supprimer l'événement ?",
    delete_event_confirm: "Cette action est irréversible. Tous les cadeaux de cet événement seront également supprimés.",
    edit_event: "Modifier l'événement",
    enter_event_name: "Entrez le nom de l'événement",
    gift_added: "Cadeau ajouté",
    gift_updated: "Cadeau mis à jour",
    gift_deleted: "Cadeau supprimé",
    link_copied: "Lien copié !",
    
    
    // Admin
    admin_panel: "Panneau d'administration",
    new_last_30_days: "30 derniers jours",
    
    // Auth Modal
    welcome_back: "Bon retour",
    create_account: "Créer un compte",
    login_subtitle: "Connectez-vous pour continuer",
    register_subtitle: "Rejoignez-nous gratuitement",
    continue_google: "Continuer avec Google",
    or: "ou",
    name_placeholder: "Votre nom",
    password: "Mot de passe",
    show_password: "Afficher le mot de passe",
    hide_password: "Masquer le mot de passe",
    sign_in: "Se connecter",
    sign_up: "S'inscrire",
    no_account: "Pas de compte ?",
    have_account: "Déjà un compte ?",
    email_required: "Email requis",
    email_invalid: "Email invalide",
    password_required: "Mot de passe requis",
    password_min: "Minimum 6 caractères",
    name_required: "Nom requis",
    login_success: "Bienvenue !",
    register_success: "Compte créé !",
    remember_me: "Se souvenir de moi",
    forgot_password: "Mot de passe oublié ?",
    forgot_subtitle: "Entrez email pour récupérer",
    send_reset_link: "Envoyer le lien",
    check_email: "Vérifiez votre email",
    reset_email_sent: "Nous avons envoyé un lien de réinitialisation à",
    back_to_login: "Retour à la connexion",
    
    // Countdown
    countdown_days: "jours",
    countdown_hours: "heures",
    countdown_minutes: "minutes",
    countdown_seconds: "secondes",
    event_passed: "Événement passé",
    
    // Gift link
    gift_link_btn: "Lien vers le cadeau",
    show_gift: "Voir le cadeau",
    
    // Reservation
    expires: "Expire",
    reservation_expired: "Réservation expirée",
    reservation_permanent: "Réservation permanente",
    reservation_expires_in: "Expire dans",
    show_more: "Voir plus",
    show_less: "Voir moins",
    bought: "Acheté",
    mark_bought: "Acheté",
    gift_bought: "Cadeau marqué comme acheté !",
    show_timer_label: "Afficher le minuteur de réservation",
    show_timer_hint: "Les amis verront le temps restant",
    
    // Suggestions
    suggest_gift: "Suggérer un cadeau",
    suggest_description: "Suggérez une idée de cadeau pour cette liste",
    suggestion_sent: "Suggestion envoyée !",
    pending_suggestions: "Suggestions des amis",
    no_suggestions: "Pas de nouvelles suggestions",
    approve: "Ajouter",
    reject: "Refuser",
    suggestion_approved: "Suggestion ajoutée à la liste",
    suggestion_rejected: "Suggestion refusée",
    suggested_by: "Suggéré par :",
    
    // Telegram
    telegram_desc: "Recevez des notifications sur les réservations et contributions via Telegram",
    telegram_connected: "Connecté",
    telegram_notifications_desc: "Vous recevrez des notifications sur les réservations de cadeaux, les contributions à la cagnotte et les suggestions d'amis.",
    telegram_link_desc: "Cliquez sur le bouton ci-dessous pour ouvrir le bot et lier votre compte :",
    telegram_code_expires: "Code valide 10 minutes",
    telegram_unlinked: "Telegram déconnecté",
    open_telegram: "Ouvrir Telegram",
    disconnect: "Déconnecter",
    
    // PWA
    install_app: "Installer l'application",
    install_app_desc: "Ajoutez Gift-Wish à votre écran d'accueil pour un accès rapide",
    install: "Installer",
    not_now: "Pas maintenant",
    
    // Password reset
    reset_password: "Réinitialiser le mot de passe",
    new_password: "Nouveau mot de passe",
    confirm_password: "Confirmer le mot de passe",
    password_reset_success: "Mot de passe réinitialisé !",
    invalid_token: "Token invalide ou expiré",
    
    // Admin panel
    admin_dashboard: "Tableau de bord",
    admin_users: "Utilisateurs",
    admin_events: "Événements",
    admin_clicks: "Clics affiliés",
    admin_export: "Exporter les données",
    search: "Rechercher...",
    actions: "Actions",
    ban: "Bannir",
    unban: "Débannir",
    banned: "Banni",
    confirm_ban: "Êtes-vous sûr de vouloir bannir cet utilisateur ?",
    confirm_delete: "Êtes-vous sûr de vouloir supprimer ?",
    user_banned: "Utilisateur banni",
    user_unbanned: "Utilisateur débanni",
    user_deleted: "Utilisateur supprimé",
    export_csv: "Exporter CSV",
    no_data: "Pas de données",
    total_users: "Total utilisateurs",
    total_events: "Total événements",
    total_gifts: "Total cadeaux",
    total_reservations: "Total réservations",
    total_clicks: "Total clics",
    daily_activity: "Activité quotidienne",
    top_products: "Produits populaires",
    clicks_by_type: "Clics par type",
    clicks: "Clics",
    
    // Affiliate
    amazon: "Amazon",
    aliexpress: "AliExpress",
    ebay: "eBay",
    other: "Autre",
    short_amazon_warning: "Les liens Amazon courts peuvent perdre le suivi. Utilisez l'URL complète.",
    link_resolved: "Lien résolu",
    
    // Navigation Sidebar
    nav_overview: "Aperçu",
    nav_my_lists: "Mes listes",
    nav_groups: "Groupes",
    nav_invitations: "Invitations",
    nav_settings: "Paramètres",
    sign_out: "Se déconnecter",
    hide_menu: "Masquer le menu",
    show_menu: "Afficher le menu",
    your_code: "Votre code",
    code_copied: "Code copié !",
    pending_invitations: "En attente",
    no_pending_invitations: "Aucune invitation en attente",
    invited_by: "Invité par",
    invitation_accepted: "Invitation acceptée !",
    invitation_declined: "Invitation refusée",
    invitation_history: "Historique",
    accepted: "Accepté",
    declined: "Refusé",
    accept: "Accepter",
    settings_saved: "Paramètres enregistrés",
    language_region: "Langue et région",
    language_region_desc: "Choisissez votre langue et région préférées",
    notifications: "Notifications",
    notifications_desc: "Gérez comment vous recevez les notifications",
    email_event_reminders: "Rappels d'événements",
    email_event_reminders_desc: "Recevoir des rappels avant les événements",
    email_gift_updates: "Mises à jour des cadeaux",
    email_gift_updates_desc: "Quand les cadeaux sont réservés ou achetés",
    email_invitations: "Notifications d'invitation",
    email_invitations_desc: "Quand quelqu'un vous invite à un événement",
    
    // Notification settings - Categories
    notification_categories: "Par catégories d'événements",
    notification_categories_desc: "Choisissez pour quels événements recevoir des emails",
    notification_confirmations: "Confirmations par email",
    notification_confirmations_desc: "Notifications sur les actions de vos cadeaux",
    email_confirm_reservation: "Réservations de cadeaux",
    email_confirm_reservation_desc: "Quand quelqu'un réserve votre cadeau",
    email_confirm_contribution: "Contributions cagnottes",
    email_confirm_contribution_desc: "Quand quelqu'un contribue à votre cadeau",
    email_confirm_suggestion: "Suggestions de cadeaux",
    email_confirm_suggestion_desc: "Quand quelqu'un vous suggère un cadeau",
    email_confirm_invitation: "Invitations",
    email_confirm_invitation_desc: "Invitations aux groupes et événements",
    email_confirm_reminder: "Rappels",
    email_confirm_reminder_desc: "Rappels des événements à venir",
    push_notifications: "Notifications push",
    push_notifications_desc: "Notifications navigateur et mobile",
    push_not_supported: "Non supporté",
    push_permission_granted: "Permission accordée",
    push_permission_denied: "Permission refusée",
    push_permission_required: "Permission requise",
    push_browser_not_supported: "Le navigateur ne supporte pas les notifications push",
    push_active: "Actif",
    push_inactive: "Inactif",
    push_receive_notifications: "Recevoir des notifications",
    push_about_events: "À propos des événements, cadeaux et messages",
    push_enabled_success: "Notifications push activées!",
    push_enable: "Activer les notifications",
    push_test: "Tester",
    push_disable: "Désactiver",
    push_disabled_success: "Notifications push désactivées",
    all_categories_on: "Tout activer",
    all_categories_off: "Tout désactiver",
    
    privacy: "Confidentialité",
    privacy_desc: "Contrôlez vos paramètres de confidentialité",
    public_profile: "Profil public",
    public_profile_desc: "Les autres peuvent voir votre profil",
    show_wishlists: "Afficher les listes de souhaits",
    show_wishlists_desc: "Afficher les listes sur votre profil",
    account: "Compte",
    help_support: "Aide et support",
    coming_soon: "Bientôt disponible",
    logged_out: "Vous avez été déconnecté",
    premium: "Premium",
    trusted_by: "Des milliers",
    happy_users: "nous font confiance",
    no_duplicates: "Sans doublons",
    smart_reservation: "Réservation intelligente",
    open_list: "Ouvrir la liste",
    search_placeholder: "Rechercher amis ou événements...",
    invitations: "Invitations",
    my_events_section: "Mes Événements",
    see_all: "TOUT",
    view_gifts: "Voir les cadeaux",
    gifts_progress: "cadeaux",
    no_invitations: "Pas d'invitations",
    event_from: "de",
    
    // Groups - Missing translations
    create_group: "Créer un groupe",
    groups_coming_soon: "Groupes bientôt disponibles",
    groups_coming_soon_desc: "Créez des groupes avec vos amis et votre famille pour coordonner les cadeaux.",
    back_to_dashboard: "Retour au tableau de bord",
    my_groups: "Mes groupes",
    no_groups: "Pas encore de groupes",
    no_groups_desc: "Créez un groupe pour coordonner les cadeaux",
    create_first_group: "Créer votre premier groupe",
    members: "membres",
    invite_members: "Inviter des membres",
    create_group_desc: "Créez un groupe pour coordonner les cadeaux",
    group_name: "Nom du groupe",
    group_name_placeholder: "Ex: Noël en famille",
    description: "Description",
    group_desc_placeholder: "À quoi sert ce groupe?",
    private_group: "Groupe privé",
    group_created: "Groupe créé!",
    invitation_sent: "Invitation envoyée!",
    by_username: "Par nom d'utilisateur",
    by_link: "Par lien",
    search_username: "Rechercher par utilisateur ou ID",
    or_enter_code: "Ou entrez le code",
    invite: "Inviter",
    share_link: "Partager le lien",
    link_desc: "Toute personne avec ce lien peut rejoindre",
    qr_desc: "Scannez pour rejoindre le groupe",
    owner: "Propriétaire",
    leave_group: "Quitter le groupe",
    delete_group: "Supprimer le groupe",
    left_group: "Vous avez quitté le groupe",
    group_deleted: "Groupe supprimé",
    confirm_leave: "Êtes-vous sûr de vouloir quitter ce groupe?",
    confirm_delete_group: "Êtes-vous sûr de vouloir supprimer ce groupe?",
    group_not_found: "Groupe non trouvé",
    decline: "Refuser",
    from: "de",
    view: "Voir",
    
    // Group tabs
    events: "Événements",
    chat: "Discussion",
    secret_santa: "Père Noël Secret",
    
    // Group events
    share_event: "Partager l'événement",
    share_event_desc: "Partagez votre événement avec ce groupe",
    no_shared_events: "Pas d'événements partagés",
    no_events_to_share: "Vous n'avez pas d'événements à partager",
    all_events_shared: "Tous vos événements sont déjà partagés",
    event_shared: "Événement partagé!",
    event_removed: "Événement retiré du groupe",
    shared_by: "Partagé par",
    
    // Group chat
    type_message: "Écrivez un message...",
    message: "Message",
    no_messages: "Pas encore de messages",
    connected: "Connecté",
    connecting: "Connexion...",
    typing: "écrit...",
    
    // Secret Santa
    create_santa: "Créer Père Noël Secret",
    santa_desc: "Organisez un échange de cadeaux secret",
    santa_setup_desc: "Définissez le budget et la date",
    min_budget: "Budget minimum",
    max_budget: "Budget maximum",
    exchange_date: "Date d'échange",
    santa_message_placeholder: "Message optionnel pour les participants...",
    start_santa: "Lancer le tirage",
    need_3_members: "Au moins 3 membres requis",
    secret_santa_active: "Père Noël Secret actif!",
    you_give_to: "Vous offrez à",
    reveal: "Révéler",
    confirm_reveal: "Révéler tous les appariements?",
    santa_revealed: "Père Noël Secret révélé!",
    santa_cancelled: "Père Noël Secret annulé",
    confirm_cancel_santa: "Annuler Père Noël Secret?",
    
    // Transfer ownership
    transfer_ownership: "Transférer la propriété",
    select_new_owner: "Sélectionner nouveau propriétaire",
    select_member: "Sélectionner un membre",
    transfer: "Transférer",
    transfer_warning: "Cette action est irréversible",
    ownership_transferred: "Propriété transférée",
  },
  
  de: {
    app_name: "Gift-Wish",
    reservation_time: "Reservierungszeit",
    free_for_all: "Kostenlos für alle",
    login: "Anmelden",
    logout: "Abmelden",
    my_lists: "Meine Listen",
    back: "← Zurück",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    add: "Hinzufügen",
    create: "Erstellen",
    share: "Teilen",
    copied: "Kopiert!",
    loading: "Laden...",
    error: "Fehler",
    success: "Erfolg",
    too_many_requests: "Zu viele Versuche. Bitte versuchen Sie es später.",
    email_already_registered: "Diese E-Mail ist bereits registriert",
    invalid_credentials: "Ungültige E-Mail oder Passwort",
    password_too_short: "Das Passwort muss mindestens 6 Zeichen lang sein",
    
    hero_title: "Perfekte Geschenke",
    hero_title_accent: "ohne Überraschungen",
    hero_description: "Erstellen Sie eine Wunschliste und teilen Sie sie mit Freunden. Sie reservieren Geschenke — niemand schenkt das Gleiche.",
    create_list: "Liste erstellen",
    learn_more: "Mehr erfahren",
    how_it_works: "So funktioniert es",
    simple_process: "Ein einfacher 4-Schritte-Prozess für perfekte Geschenke",
    for_any_occasion: "Für jeden Anlass",
    not_only_birthday: "Erstellen Sie Listen für mehr als nur Geburtstage",
    ready_to_create: "Bereit, Ihre Liste zu erstellen?",
    join_free: "Kostenlos beitreten und perfekte Geschenke erhalten",
    start_free: "Kostenlos starten",
    all_rights: "Alle Rechte vorbehalten.",
    privacy_policy: "Datenschutz",
    terms_of_service: "AGB",
    contact: "Kontakt",
    
    feature_gifts: "Geschenklisten",
    feature_gifts_desc: "Listen für jeden Anlass erstellen",
    feature_share: "Link teilen",
    feature_share_desc: "An Freunde oder Social Media senden",
    feature_reserve: "Reservierung",
    feature_reserve_desc: "Freunde reservieren — keine Duplikate",
    feature_countdown: "Countdown",
    feature_countdown_desc: "Tage bis zum Event verfolgen",
    
    hello: "Hallo",
    manage_wishlists: "Verwalten Sie Ihre Wunschlisten",
    create_event: "Event erstellen",
    no_events: "Noch keine Events",
    create_first: "Erstellen Sie Ihr erstes Event!",
    upcoming_events: "Kommende Events",
    past_events: "Vergangene Events",
    today: "Heute!",
    days: "Tage",
    
    new_event: "Neues Event",
    event_title: "Titel",
    event_title_placeholder: "Mein Geburtstag 2026",
    event_type: "Event-Typ",
    event_date: "Event-Datum",
    currency: "Währung",
    event_description: "Beschreibung (optional)",
    event_description_placeholder: "Zusätzliche Informationen...",
    public_list: "Öffentliche Liste",
    
    event_birthday: "Geburtstag",
    event_wedding: "Hochzeit",
    event_new_year: "Neujahr",
    event_baby_shower: "Baby Shower",
    event_graduation: "Abschluss",
    event_christmas: "Weihnachten",
    event_anniversary: "Jahrestag",
    event_housewarming: "Einweihungsfeier",
    event_valentines: "Valentinstag",
    event_womens_day: "Internationaler Frauentag",
    event_mothers_day: "Muttertag",
    event_fathers_day: "Vatertag",
    event_easter: "Ostern",
    event_halloween: "Halloween",
    event_thanksgiving: "Erntedankfest",
    event_engagement: "Verlobung",
    event_retirement: "Ruhestand",
    event_promotion: "Beförderung",
    event_other: "Andere",
    
    gifts: "Geschenke",
    add_gift: "Geschenk hinzufügen",
    edit_gift: "Bearbeiten",
    gift_name: "Name",
    gift_name_placeholder: "iPhone 15 Pro",
    gift_description: "Beschreibung",
    gift_description_placeholder: "Farbe, Größe, etc.",
    gift_price: "Preis",
    gift_link: "Produktlink",
    gift_image: "Bild",
    auto_image_hint: "Oder fügen Sie den Produktlink ein — das Bild wird automatisch geladen",
    upload_image: "Bild hochladen",
    upload_hint: "JPG, PNG, GIF bis 5 MB",
    drag_drop_hint: "Datei hierher ziehen oder klicken",
    drop_here: "Zum Hochladen loslassen",
    uploading: "Wird hochgeladen...",
    image_uploaded: "Bild hochgeladen",
    upload_error: "Hochladefehler",
    invalid_file_type: "Wählen Sie ein Bild",
    file_too_large: "Maximum 5 MB",
    image_error: "Ladefehler",
    gift_priority: "Priorität",
    priority_1: "Will ich sehr",
    priority_2: "Will ich",
    priority_3: "Wäre schön",
    empty_list: "Liste leer",
    add_first_gift: "Fügen Sie Ihr erstes Geschenk hinzu",
    reserved: "reserviert",
    reserved_by: "Reserviert von:",
    link: "Link",
    events_count: "Veranstaltungen",
    search_events: "Veranstaltungen suchen...",
    search_users_placeholder: "Nach Benutzername oder Nummer suchen...",
    no_users_found: "Keine Benutzer gefunden",
    search_hint: "Mindestens 2 Zeichen eingeben",
    days_left: "Tage",
    past_event: "Vergangen",
    today: "Heute",
    archived: "Archiviert",
    no_events: "Keine Veranstaltungen",
    create_first_event: "Erstellen Sie Ihre erste Veranstaltung",
    
    // Archive
    archive: "Erinnerungsarchiv",
    save_as_memory: "Als Erinnerung speichern",
    archived_events: "Archivierte Events",
    no_archived_events: "Keine archivierten Events",
    restore_event: "Wiederherstellen",
    event_archived: "Event archiviert",
    event_restored: "Event wiederhergestellt",
    
    // Crowdfunding
    crowdfunding: "Sammelaktion",
    enable_crowdfunding: "Sammelaktion aktivieren",
    goal_amount: "Zielbetrag",
    collected: "Gesammelt",
    contribute: "Beitragen",
    contribution_amount: "Beitragshöhe",
    contribution_message: "Nachricht (optional)",
    contribution_hint: "Geben Sie den Betrag ein, den Sie für dieses Geschenk beitragen möchten",
    message_placeholder: "Alles Gute zum Geburtstag!",
    contribution_success: "Beitrag hinzugefügt!",
    contributors: "Teilnehmer",
    no_contributions: "Noch keine Beiträge",
    crowdfunding_hint: "Freunde können zu diesem Geschenk beitragen",
    promised: "Versprochen",
    view_contributions: "Beiträge",
    contributions_list: "Beitragsliste",
    total: "Gesamt",
    
    wishlist_from: "Wunschliste von",
    in_days: "In",
    reserved_gifts: "Reservierte Geschenke",
    of: "von",
    wishlist_not_found: "Liste nicht gefunden",
    wrong_link: "Der Link ist möglicherweise falsch oder die Liste ist privat",
    
    reserve_gift: "Geschenk reservieren",
    reserve_description: "Geben Sie Ihren Namen ein, damit andere wissen, dass dieses Geschenk reserviert ist",
    your_name: "Ihr Name",
    your_name_placeholder: "Wie heißen Sie?",
    reserve: "Reservieren",
    gift_reserved: "Geschenk reserviert!",
    
    affiliate_note: "Mit dem Kauf über diesen Link unterstützen Sie den Service",
    buy_now: "Kaufen",
    
    error_loading: "Ladefehler",
    error_creating: "Erstellungsfehler",
    error_saving: "Speicherfehler",
    error_deleting: "Löschfehler",
    error_reserving: "Reservierungsfehler",
    error_auth: "Authentifizierungsfehler",
    fill_required: "Füllen Sie die Pflichtfelder aus",
    enter_name: "Geben Sie Ihren Namen ein",
    enter_gift_name: "Geben Sie den Geschenknamen ein",
    event_archived_message: "Dieses Event ist beendet und wurde archiviert",
    event_no_longer_available: "Diese Wunschliste ist nicht mehr verfügbar",
    
    event_created: "Event erstellt!",
    event_updated: "Event aktualisiert",
    event_deleted: "Event gelöscht",
    delete_event_title: "Event löschen?",
    delete_event_confirm: "Diese Aktion kann nicht rückgängig gemacht werden. Alle Geschenke in diesem Event werden ebenfalls gelöscht.",
    edit_event: "Event bearbeiten",
    enter_event_name: "Geben Sie den Eventnamen ein",
    gift_added: "Geschenk hinzugefügt",
    gift_updated: "Geschenk aktualisiert",
    gift_deleted: "Geschenk gelöscht",
    link_copied: "Link kopiert!",
    
    
    // Admin
    admin_panel: "Admin-Panel",
    new_last_30_days: "Letzte 30 Tage",
    
    // Auth Modal
    welcome_back: "Willkommen zurück",
    create_account: "Konto erstellen",
    login_subtitle: "Melden Sie sich an, um fortzufahren",
    register_subtitle: "Kostenlos beitreten",
    continue_google: "Mit Google fortfahren",
    or: "oder",
    name_placeholder: "Ihr Name",
    password: "Passwort",
    show_password: "Passwort anzeigen",
    hide_password: "Passwort verbergen",
    sign_in: "Anmelden",
    sign_up: "Registrieren",
    no_account: "Kein Konto?",
    have_account: "Bereits ein Konto?",
    email_required: "E-Mail erforderlich",
    email_invalid: "Ungültige E-Mail",
    password_required: "Passwort erforderlich",
    password_min: "Mindestens 6 Zeichen",
    name_required: "Name erforderlich",
    login_success: "Willkommen!",
    register_success: "Konto erstellt!",
    remember_me: "Angemeldet bleiben",
    forgot_password: "Passwort vergessen?",
    forgot_subtitle: "E-Mail zur Wiederherstellung eingeben",
    send_reset_link: "Link senden",
    check_email: "Überprüfen Sie Ihre E-Mail",
    reset_email_sent: "Wir haben einen Reset-Link gesendet an",
    back_to_login: "Zurück zur Anmeldung",
    
    // Countdown
    countdown_days: "Tage",
    countdown_hours: "Stunden",
    countdown_minutes: "Minuten",
    countdown_seconds: "Sekunden",
    event_passed: "Event vorbei",
    
    // Gift link
    gift_link_btn: "Link zum Geschenk",
    show_gift: "Geschenk ansehen",
    
    // Reservation
    expires: "Läuft ab",
    reservation_expired: "Reservierung abgelaufen",
    reservation_permanent: "Dauerhafte Reservierung",
    reservation_expires_in: "Läuft ab in",
    show_more: "Mehr anzeigen",
    show_less: "Weniger anzeigen",
    bought: "Gekauft",
    mark_bought: "Gekauft",
    gift_bought: "Geschenk als gekauft markiert!",
    show_timer_label: "Reservierungs-Timer anzeigen",
    show_timer_hint: "Freunde sehen die verbleibende Zeit",
    
    // Suggestions
    suggest_gift: "Geschenk vorschlagen",
    suggest_description: "Schlagen Sie eine Geschenkidee für diese Liste vor",
    suggestion_sent: "Vorschlag gesendet!",
    pending_suggestions: "Vorschläge von Freunden",
    no_suggestions: "Keine neuen Vorschläge",
    approve: "Hinzufügen",
    reject: "Ablehnen",
    suggestion_approved: "Vorschlag zur Liste hinzugefügt",
    suggestion_rejected: "Vorschlag abgelehnt",
    suggested_by: "Vorgeschlagen von:",
    
    // Telegram
    telegram_desc: "Erhalten Sie Benachrichtigungen über Reservierungen und Beiträge via Telegram",
    telegram_connected: "Verbunden",
    telegram_notifications_desc: "Sie erhalten Benachrichtigungen über Geschenkreservierungen, Sammelbeiträge und Vorschläge von Freunden.",
    telegram_link_desc: "Klicken Sie auf die Schaltfläche unten, um den Bot zu öffnen und Ihr Konto zu verknüpfen:",
    telegram_code_expires: "Code gültig für 10 Minuten",
    telegram_unlinked: "Telegram getrennt",
    open_telegram: "Telegram öffnen",
    disconnect: "Trennen",
    
    // PWA
    install_app: "App installieren",
    install_app_desc: "Fügen Sie Gift-Wish zu Ihrem Startbildschirm hinzu für schnellen Zugriff",
    install: "Installieren",
    not_now: "Nicht jetzt",
    
    // Password reset
    reset_password: "Passwort zurücksetzen",
    new_password: "Neues Passwort",
    confirm_password: "Passwort bestätigen",
    password_reset_success: "Passwort erfolgreich zurückgesetzt!",
    invalid_token: "Ungültiger oder abgelaufener Token",
    
    // Admin panel
    admin_dashboard: "Dashboard",
    admin_users: "Benutzer",
    admin_events: "Ereignisse",
    admin_clicks: "Affiliate-Klicks",
    admin_export: "Daten exportieren",
    search: "Suchen...",
    actions: "Aktionen",
    ban: "Sperren",
    unban: "Entsperren",
    banned: "Gesperrt",
    confirm_ban: "Möchten Sie diesen Benutzer wirklich sperren?",
    confirm_delete: "Möchten Sie wirklich löschen?",
    user_banned: "Benutzer gesperrt",
    user_unbanned: "Benutzer entsperrt",
    user_deleted: "Benutzer gelöscht",
    export_csv: "CSV exportieren",
    no_data: "Keine Daten",
    total_users: "Benutzer gesamt",
    total_events: "Ereignisse gesamt",
    total_gifts: "Geschenke gesamt",
    total_reservations: "Reservierungen gesamt",
    total_clicks: "Klicks gesamt",
    daily_activity: "Tägliche Aktivität",
    top_products: "Top-Produkte",
    clicks_by_type: "Klicks nach Typ",
    clicks: "Klicks",
    
    // Affiliate
    amazon: "Amazon",
    aliexpress: "AliExpress",
    ebay: "eBay",
    other: "Andere",
    short_amazon_warning: "Kurze Amazon-Links können das Tracking verlieren. Bitte verwenden Sie die vollständige URL.",
    link_resolved: "Link aufgelöst",
    
    // Navigation Sidebar
    nav_overview: "Übersicht",
    nav_my_lists: "Meine Listen",
    nav_groups: "Gruppen",
    nav_invitations: "Einladungen",
    nav_settings: "Einstellungen",
    sign_out: "Abmelden",
    hide_menu: "Menü ausblenden",
    show_menu: "Menü anzeigen",
    your_code: "Ihr Code",
    code_copied: "Code kopiert!",
    pending_invitations: "Ausstehend",
    no_pending_invitations: "Keine ausstehenden Einladungen",
    invited_by: "Eingeladen von",
    invitation_accepted: "Einladung angenommen!",
    invitation_declined: "Einladung abgelehnt",
    invitation_history: "Verlauf",
    accepted: "Angenommen",
    declined: "Abgelehnt",
    accept: "Annehmen",
    settings_saved: "Einstellungen gespeichert",
    language_region: "Sprache und Region",
    language_region_desc: "Wählen Sie Ihre bevorzugte Sprache und Region",
    notifications: "Benachrichtigungen",
    notifications_desc: "Verwalten Sie, wie Sie Benachrichtigungen erhalten",
    email_event_reminders: "Ereigniserinnerungen",
    email_event_reminders_desc: "Erinnerungen vor Ereignissen erhalten",
    email_gift_updates: "Geschenk-Updates",
    email_gift_updates_desc: "Wenn Geschenke reserviert oder gekauft werden",
    email_invitations: "Einladungsbenachrichtigungen",
    email_invitations_desc: "Wenn Sie jemand zu einer Veranstaltung einlädt",
    
    // Notification settings - Categories
    notification_categories: "Nach Ereigniskategorien",
    notification_categories_desc: "Wählen Sie, für welche Ereignisse Sie E-Mails erhalten",
    notification_confirmations: "E-Mail-Bestätigungen",
    notification_confirmations_desc: "Benachrichtigungen über Aktionen bei Ihren Geschenken",
    email_confirm_reservation: "Geschenkreservierungen",
    email_confirm_reservation_desc: "Wenn jemand Ihr Geschenk reserviert",
    email_confirm_contribution: "Sammelbeiträge",
    email_confirm_contribution_desc: "Wenn jemand zu Ihrem Geschenk beiträgt",
    email_confirm_suggestion: "Geschenkvorschläge",
    email_confirm_suggestion_desc: "Wenn jemand Ihnen ein Geschenk vorschlägt",
    email_confirm_invitation: "Einladungen",
    email_confirm_invitation_desc: "Einladungen zu Gruppen und Veranstaltungen",
    email_confirm_reminder: "Erinnerungen",
    email_confirm_reminder_desc: "Erinnerungen an bevorstehende Ereignisse",
    push_notifications: "Push-Benachrichtigungen",
    push_notifications_desc: "Browser- und Mobilbenachrichtigungen",
    push_not_supported: "Nicht unterstützt",
    push_permission_granted: "Berechtigung erteilt",
    push_permission_denied: "Berechtigung verweigert",
    push_permission_required: "Berechtigung erforderlich",
    push_browser_not_supported: "Browser unterstützt keine Push-Benachrichtigungen",
    push_active: "Aktiv",
    push_inactive: "Inaktiv",
    push_receive_notifications: "Benachrichtigungen erhalten",
    push_about_events: "Über Events, Geschenke und Nachrichten",
    push_enabled_success: "Push-Benachrichtigungen aktiviert!",
    push_enable: "Benachrichtigungen aktivieren",
    push_test: "Testen",
    push_disable: "Deaktivieren",
    push_disabled_success: "Push-Benachrichtigungen deaktiviert",
    all_categories_on: "Alle aktivieren",
    all_categories_off: "Alle deaktivieren",
    
    privacy: "Datenschutz",
    privacy_desc: "Kontrollieren Sie Ihre Datenschutzeinstellungen",
    public_profile: "Öffentliches Profil",
    public_profile_desc: "Andere können Ihr Profil sehen",
    show_wishlists: "Wunschlisten anzeigen",
    show_wishlists_desc: "Wunschlisten auf Ihrem Profil anzeigen",
    account: "Konto",
    help_support: "Hilfe und Support",
    coming_soon: "Demnächst verfügbar",
    logged_out: "Sie wurden abgemeldet",
    premium: "Premium",
    trusted_by: "Tausende vertrauen",
    happy_users: "uns",
    no_duplicates: "Keine Duplikate",
    smart_reservation: "Intelligente Reservierung",
    open_list: "Liste öffnen",
    search_placeholder: "Freunde oder Events suchen...",
    invitations: "Einladungen",
    my_events_section: "Meine Events",
    see_all: "ALLE",
    view_gifts: "Geschenke ansehen",
    gifts_progress: "Geschenke",
    no_invitations: "Keine Einladungen",
    event_from: "von",
    
    // Groups - Missing translations
    create_group: "Gruppe erstellen",
    groups_coming_soon: "Gruppen bald verfügbar",
    groups_coming_soon_desc: "Erstellen Sie Gruppen mit Freunden und Familie, um Geschenke zu koordinieren.",
    back_to_dashboard: "Zurück zum Dashboard",
    my_groups: "Meine Gruppen",
    no_groups: "Noch keine Gruppen",
    no_groups_desc: "Erstellen Sie eine Gruppe, um Geschenke zu koordinieren",
    create_first_group: "Erste Gruppe erstellen",
    members: "Mitglieder",
    invite_members: "Mitglieder einladen",
    create_group_desc: "Erstellen Sie eine Gruppe, um Geschenke zu koordinieren",
    group_name: "Gruppenname",
    group_name_placeholder: "z.B. Familien-Weihnachten",
    description: "Beschreibung",
    group_desc_placeholder: "Wofür ist diese Gruppe?",
    private_group: "Private Gruppe",
    group_created: "Gruppe erstellt!",
    invitation_sent: "Einladung gesendet!",
    by_username: "Nach Benutzername",
    by_link: "Per Link",
    search_username: "Nach Benutzer oder ID suchen",
    or_enter_code: "Oder Code eingeben",
    invite: "Einladen",
    share_link: "Link teilen",
    link_desc: "Jeder mit diesem Link kann beitreten",
    qr_desc: "Scannen zum Beitreten",
    owner: "Eigentümer",
    leave_group: "Gruppe verlassen",
    delete_group: "Gruppe löschen",
    left_group: "Sie haben die Gruppe verlassen",
    group_deleted: "Gruppe gelöscht",
    confirm_leave: "Möchten Sie diese Gruppe wirklich verlassen?",
    confirm_delete_group: "Möchten Sie diese Gruppe wirklich löschen?",
    group_not_found: "Gruppe nicht gefunden",
    decline: "Ablehnen",
    from: "von",
    view: "Ansehen",
    
    // Group tabs
    events: "Events",
    chat: "Chat",
    secret_santa: "Wichteln",
    
    // Group events
    share_event: "Event teilen",
    share_event_desc: "Teilen Sie Ihr Event mit dieser Gruppe",
    no_shared_events: "Keine geteilten Events",
    no_events_to_share: "Sie haben keine Events zum Teilen",
    all_events_shared: "Alle Ihre Events sind bereits geteilt",
    event_shared: "Event geteilt!",
    event_removed: "Event aus Gruppe entfernt",
    shared_by: "Geteilt von",
    
    // Group chat
    type_message: "Nachricht schreiben...",
    message: "Nachricht",
    no_messages: "Noch keine Nachrichten",
    connected: "Verbunden",
    connecting: "Verbinde...",
    typing: "schreibt...",
    
    // Secret Santa
    create_santa: "Wichteln erstellen",
    santa_desc: "Organisieren Sie einen geheimen Geschenkaustausch",
    santa_setup_desc: "Budget und Datum festlegen",
    min_budget: "Mindestbudget",
    max_budget: "Maximalbudget",
    exchange_date: "Austauschdatum",
    santa_message_placeholder: "Optionale Nachricht für Teilnehmer...",
    start_santa: "Auslosung starten",
    need_3_members: "Mindestens 3 Mitglieder erforderlich",
    secret_santa_active: "Wichteln aktiv!",
    you_give_to: "Sie schenken an",
    reveal: "Aufdecken",
    confirm_reveal: "Alle Zuordnungen aufdecken?",
    santa_revealed: "Wichteln aufgedeckt!",
    santa_cancelled: "Wichteln abgesagt",
    confirm_cancel_santa: "Wichteln abbrechen?",
    
    // Transfer ownership
    transfer_ownership: "Eigentum übertragen",
    select_new_owner: "Neuen Eigentümer wählen",
    select_member: "Mitglied auswählen",
    transfer: "Übertragen",
    transfer_warning: "Diese Aktion kann nicht rückgängig gemacht werden",
    ownership_transferred: "Eigentum übertragen",
  },
  
  cs: {
    app_name: "Gift-Wish",
    reservation_time: "Čas rezervace",
    free_for_all: "Zdarma pro všechny",
    login: "Přihlásit se",
    logout: "Odhlásit se",
    my_lists: "Moje seznamy",
    back: "← Zpět",
    save: "Uložit",
    cancel: "Zrušit",
    delete: "Smazat",
    edit: "Upravit",
    add: "Přidat",
    create: "Vytvořit",
    share: "Sdílet",
    copied: "Zkopírováno!",
    loading: "Načítání...",
    error: "Chyba",
    success: "Úspěch",
    too_many_requests: "Příliš mnoho pokusů. Zkuste to později.",
    email_already_registered: "Tento email je již zaregistrován",
    invalid_credentials: "Neplatný email nebo heslo",
    password_too_short: "Heslo musí mít alespoň 6 znaků",
    
    hero_title: "Perfektní dárky",
    hero_title_accent: "bez překvapení",
    hero_description: "Vytvořte seznam přání a sdílejte ho s přáteli. Rezervují dárky — nikdo nedá to samé.",
    create_list: "Vytvořit seznam",
    learn_more: "Zjistit více",
    how_it_works: "Jak to funguje",
    simple_process: "Jednoduchý 4krokový proces k perfektním dárkům",
    for_any_occasion: "Pro každou příležitost",
    not_only_birthday: "Vytvářejte seznamy nejen pro narozeniny",
    ready_to_create: "Připraveni vytvořit svůj seznam?",
    join_free: "Přidejte se zdarma a začněte dostávat perfektní dárky",
    start_free: "Začít zdarma",
    all_rights: "Všechna práva vyhrazena.",
    privacy_policy: "Soukromí",
    terms_of_service: "Podmínky",
    contact: "Kontakt",
    
    feature_gifts: "Seznamy dárků",
    feature_gifts_desc: "Vytvářejte seznamy pro jakoukoli událost",
    feature_share: "Sdílejte odkaz",
    feature_share_desc: "Pošlete přátelům nebo na sociální sítě",
    feature_reserve: "Rezervace",
    feature_reserve_desc: "Přátelé rezervují — žádné duplikáty",
    feature_countdown: "Odpočet",
    feature_countdown_desc: "Sledujte dny do události",
    
    hello: "Ahoj",
    manage_wishlists: "Spravujte své seznamy přání",
    create_event: "Vytvořit událost",
    no_events: "Zatím žádné události",
    create_first: "Vytvořte svou první událost!",
    upcoming_events: "Nadcházející události",
    past_events: "Minulé události",
    today: "Dnes!",
    days: "dní",
    
    new_event: "Nová událost",
    event_title: "Název",
    event_title_placeholder: "Moje narozeniny 2026",
    event_type: "Typ události",
    event_date: "Datum události",
    currency: "Měna",
    event_description: "Popis (volitelné)",
    event_description_placeholder: "Další informace...",
    public_list: "Veřejný seznam",
    
    event_birthday: "Narozeniny",
    event_wedding: "Svatba",
    event_new_year: "Nový rok",
    event_baby_shower: "Baby Shower",
    event_graduation: "Promoce",
    event_christmas: "Vánoce",
    event_anniversary: "Výročí",
    event_housewarming: "Kolaudace",
    event_valentines: "Valentýn",
    event_womens_day: "Mezinárodní den žen",
    event_mothers_day: "Den matek",
    event_fathers_day: "Den otců",
    event_easter: "Velikonoce",
    event_halloween: "Halloween",
    event_thanksgiving: "Den díkůvzdání",
    event_engagement: "Zasnoubení",
    event_retirement: "Důchod",
    event_promotion: "Povýšení",
    event_other: "Jiné",
    
    gifts: "Dárky",
    add_gift: "Přidat dárek",
    edit_gift: "Upravit",
    gift_name: "Název",
    gift_name_placeholder: "iPhone 15 Pro",
    gift_description: "Popis",
    gift_description_placeholder: "Barva, velikost atd.",
    gift_price: "Cena",
    gift_link: "Odkaz na produkt",
    gift_image: "Obrázek",
    auto_image_hint: "Nebo vložte odkaz na produkt — obrázek se načte automaticky",
    upload_image: "Nahrát obrázek",
    upload_hint: "JPG, PNG, GIF do 5 MB",
    drag_drop_hint: "Přetáhněte soubor sem nebo klikněte",
    drop_here: "Pusťte pro nahrání",
    uploading: "Nahrávání...",
    image_uploaded: "Obrázek nahrán",
    upload_error: "Chyba nahrávání",
    invalid_file_type: "Vyberte obrázek",
    file_too_large: "Maximum 5 MB",
    image_error: "Chyba načítání",
    gift_priority: "Priorita",
    priority_1: "Moc chci",
    priority_2: "Chci",
    priority_3: "Bylo by fajn",
    empty_list: "Seznam je prázdný",
    add_first_gift: "Přidejte svůj první dárek",
    reserved: "rezervováno",
    reserved_by: "Rezervoval:",
    link: "Odkaz",
    events_count: "událostí",
    search_events: "Hledat události...",
    search_users_placeholder: "Hledat podle uživatele nebo čísla...",
    no_users_found: "Žádní uživatelé nenalezeni",
    search_hint: "Zadejte alespoň 2 znaky",
    days_left: "dní",
    past_event: "Minulá",
    today: "Dnes",
    archived: "Archivováno",
    no_events: "Žádné události",
    create_first_event: "Vytvořte svou první událost",
    
    // Archive
    archive: "Archiv vzpomínek",
    save_as_memory: "Uložit jako vzpomínku",
    archived_events: "Archivované události",
    no_archived_events: "Žádné archivované události",
    restore_event: "Obnovit",
    event_archived: "Událost archivována",
    event_restored: "Událost obnovena",
    
    // Crowdfunding
    crowdfunding: "Sbírka",
    enable_crowdfunding: "Povolit sbírku",
    goal_amount: "Cílová částka",
    collected: "Vybráno",
    contribute: "Přispět",
    contribution_amount: "Výše příspěvku",
    contribution_message: "Zpráva (volitelné)",
    contribution_hint: "Zadejte částku, kterou chcete přispět na tento dárek",
    message_placeholder: "Všechno nejlepší!",
    contribution_success: "Příspěvek přidán!",
    contributors: "Přispěvatelé",
    no_contributions: "Zatím žádné příspěvky",
    crowdfunding_hint: "Přátelé mohou přispět na tento dárek",
    promised: "Slíbeno",
    view_contributions: "Příspěvky",
    contributions_list: "Seznam příspěvků",
    total: "Celkem",
    
    wishlist_from: "Seznam přání od",
    in_days: "Za",
    reserved_gifts: "Rezervované dárky",
    of: "z",
    wishlist_not_found: "Seznam nenalezen",
    wrong_link: "Odkaz může být nesprávný nebo je seznam soukromý",
    
    reserve_gift: "Rezervovat dárek",
    reserve_description: "Zadejte své jméno, aby ostatní věděli, že je tento dárek rezervován",
    your_name: "Vaše jméno",
    your_name_placeholder: "Jak se jmenujete?",
    reserve: "Rezervovat",
    gift_reserved: "Dárek rezervován!",
    
    affiliate_note: "Nákupem přes tento odkaz podporujete službu",
    buy_now: "Koupit",
    
    error_loading: "Chyba načítání",
    error_creating: "Chyba vytváření",
    error_saving: "Chyba ukládání",
    error_deleting: "Chyba mazání",
    error_reserving: "Chyba rezervace",
    error_auth: "Chyba autentizace",
    fill_required: "Vyplňte povinná pole",
    enter_name: "Zadejte své jméno",
    enter_gift_name: "Zadejte název dárku",
    event_archived_message: "Tato událost skončila a byla archivována",
    event_no_longer_available: "Tento seznam přání již není dostupný",
    
    event_created: "Událost vytvořena!",
    event_updated: "Událost aktualizována",
    event_deleted: "Událost smazána",
    delete_event_title: "Smazat událost?",
    delete_event_confirm: "Tuto akci nelze vrátit zpět. Všechny dárky v této události budou také smazány.",
    edit_event: "Upravit událost",
    enter_event_name: "Zadejte název události",
    gift_added: "Dárek přidán",
    gift_updated: "Dárek aktualizován",
    gift_deleted: "Dárek smazán",
    link_copied: "Odkaz zkopírován!",
    
    
    // Admin
    admin_panel: "Administrace",
    new_last_30_days: "Za posledních 30 dní",
    
    // Auth Modal
    welcome_back: "Vítejte zpět",
    create_account: "Vytvořit účet",
    login_subtitle: "Přihlaste se pro pokračování",
    register_subtitle: "Připojte se zdarma",
    continue_google: "Pokračovat s Google",
    or: "nebo",
    name_placeholder: "Vaše jméno",
    password: "Heslo",
    show_password: "Zobrazit heslo",
    hide_password: "Skrýt heslo",
    sign_in: "Přihlásit se",
    sign_up: "Zaregistrovat se",
    no_account: "Nemáte účet?",
    have_account: "Máte účet?",
    email_required: "Email je povinný",
    email_invalid: "Neplatný email",
    password_required: "Heslo je povinné",
    password_min: "Minimálně 6 znaků",
    name_required: "Jméno je povinné",
    login_success: "Vítejte!",
    register_success: "Účet vytvořen!",
    remember_me: "Zapamatovat si mě",
    forgot_password: "Zapomněli jste heslo?",
    forgot_subtitle: "Zadejte email pro obnovení",
    send_reset_link: "Odeslat odkaz",
    check_email: "Zkontrolujte email",
    reset_email_sent: "Poslali jsme odkaz pro reset hesla na",
    back_to_login: "Zpět na přihlášení",
    
    // Countdown
    countdown_days: "dní",
    countdown_hours: "hodin",
    countdown_minutes: "minut",
    countdown_seconds: "sekund",
    event_passed: "Událost proběhla",
    
    // Gift link
    gift_link_btn: "Odkaz na dárek",
    show_gift: "Zobrazit dárek",
    
    // Reservation
    expires: "Vyprší",
    reservation_expired: "Rezervace vypršela",
    reservation_permanent: "Trvalá rezervace",
    reservation_expires_in: "Vyprší za",
    show_more: "Zobrazit více",
    show_less: "Zobrazit méně",
    bought: "Koupeno",
    mark_bought: "Koupeno",
    gift_bought: "Dárek označen jako zakoupený!",
    show_timer_label: "Zobrazit časovač rezervace",
    show_timer_hint: "Přátelé uvidí zbývající čas",
    
    // Suggestions
    suggest_gift: "Navrhnout dárek",
    suggest_description: "Navrhněte nápad na dárek pro tento seznam",
    suggestion_sent: "Návrh odeslán!",
    pending_suggestions: "Návrhy od přátel",
    no_suggestions: "Žádné nové návrhy",
    approve: "Přidat",
    reject: "Odmítnout",
    suggestion_approved: "Návrh přidán do seznamu",
    suggestion_rejected: "Návrh odmítnut",
    suggested_by: "Navrhl:",
    
    // Telegram
    telegram_desc: "Dostávejte oznámení o rezervacích a příspěvcích přes Telegram",
    telegram_connected: "Připojeno",
    telegram_notifications_desc: "Budete dostávat oznámení o rezervacích dárků, příspěvcích do sbírky a návrzích od přátel.",
    telegram_link_desc: "Klikněte na tlačítko níže pro otevření bota a propojení účtu:",
    telegram_code_expires: "Kód platí 10 minut",
    telegram_unlinked: "Telegram odpojen",
    open_telegram: "Otevřít Telegram",
    disconnect: "Odpojit",
    
    // PWA
    install_app: "Nainstalovat aplikaci",
    install_app_desc: "Přidejte Gift-Wish na domovskou obrazovku pro rychlý přístup",
    install: "Nainstalovat",
    not_now: "Teď ne",
    
    // Password reset
    reset_password: "Obnovit heslo",
    new_password: "Nové heslo",
    confirm_password: "Potvrdit heslo",
    password_reset_success: "Heslo úspěšně obnoveno!",
    invalid_token: "Neplatný nebo expirovaný token",
    
    // Admin panel
    admin_dashboard: "Přehled",
    admin_users: "Uživatelé",
    admin_events: "Události",
    admin_clicks: "Affiliate kliky",
    admin_export: "Exportovat data",
    search: "Hledat...",
    actions: "Akce",
    ban: "Zablokovat",
    unban: "Odblokovat",
    banned: "Zablokován",
    confirm_ban: "Opravdu chcete zablokovat tohoto uživatele?",
    confirm_delete: "Opravdu chcete smazat?",
    user_banned: "Uživatel zablokován",
    user_unbanned: "Uživatel odblokován",
    user_deleted: "Uživatel smazán",
    export_csv: "Exportovat CSV",
    no_data: "Žádná data",
    total_users: "Celkem uživatelů",
    total_events: "Celkem událostí",
    total_gifts: "Celkem dárků",
    total_reservations: "Celkem rezervací",
    total_clicks: "Celkem kliků",
    daily_activity: "Denní aktivita",
    top_products: "Top produkty",
    clicks_by_type: "Kliky podle typu",
    clicks: "Kliky",
    
    // Affiliate
    amazon: "Amazon",
    aliexpress: "AliExpress",
    ebay: "eBay",
    other: "Ostatní",
    short_amazon_warning: "Krátké odkazy Amazon mohou ztratit sledování. Použijte úplnou URL.",
    link_resolved: "Odkaz vyřešen",
    
    // Navigation Sidebar
    nav_overview: "Přehled",
    nav_my_lists: "Mé seznamy",
    nav_groups: "Skupiny",
    nav_invitations: "Pozvánky",
    nav_settings: "Nastavení",
    sign_out: "Odhlásit se",
    hide_menu: "Skrýt menu",
    show_menu: "Zobrazit menu",
    your_code: "Váš kód",
    code_copied: "Kód zkopírován!",
    pending_invitations: "Čekající",
    no_pending_invitations: "Žádné čekající pozvánky",
    invited_by: "Pozval",
    invitation_accepted: "Pozvánka přijata!",
    invitation_declined: "Pozvánka odmítnuta",
    invitation_history: "Historie",
    accepted: "Přijato",
    declined: "Odmítnuto",
    accept: "Přijmout",
    settings_saved: "Nastavení uloženo",
    language_region: "Jazyk a region",
    language_region_desc: "Vyberte preferovaný jazyk a region",
    notifications: "Oznámení",
    notifications_desc: "Spravujte způsob přijímání oznámení",
    email_event_reminders: "Připomínky událostí",
    email_event_reminders_desc: "Dostávat připomínky před událostmi",
    email_gift_updates: "Aktualizace dárků",
    email_gift_updates_desc: "Když jsou dárky rezervovány nebo zakoupeny",
    email_invitations: "Oznámení o pozvánkách",
    email_invitations_desc: "Když vás někdo pozve na událost",
    privacy: "Soukromí",
    privacy_desc: "Ovládejte nastavení soukromí",
    public_profile: "Veřejný profil",
    public_profile_desc: "Ostatní mohou vidět váš profil",
    show_wishlists: "Zobrazit seznamy přání",
    show_wishlists_desc: "Zobrazit seznamy na vašem profilu",
    account: "Účet",
    help_support: "Pomoc a podpora",
    coming_soon: "Již brzy",
    logged_out: "Byli jste odhlášeni",
    premium: "Premium",
    trusted_by: "Tisíce nám",
    happy_users: "důvěřují",
    no_duplicates: "Bez duplicit",
    smart_reservation: "Chytrá rezervace",
    open_list: "Otevřít seznam",
    search_placeholder: "Hledat přátele nebo události...",
    invitations: "Pozvánky",
    my_events_section: "Moje události",
    see_all: "VŠE",
    view_gifts: "Zobrazit dárky",
    gifts_progress: "dárků",
    no_invitations: "Žádné pozvánky",
    event_from: "od",
    
    // Notification settings
    notification_categories: "Podle kategorií událostí",
    notification_categories_desc: "Vyberte, pro které události dostávat emaily",
    notification_confirmations: "E-mailová potvrzení",
    notification_confirmations_desc: "Oznámení o akcích s vašimi dárky",
    email_confirm_reservation: "Rezervace dárků",
    email_confirm_reservation_desc: "Když někdo rezervuje váš dárek",
    email_confirm_contribution: "Příspěvky do sbírky",
    email_confirm_contribution_desc: "Když někdo přispěje na váš dárek",
    email_confirm_suggestion: "Návrhy dárků",
    email_confirm_suggestion_desc: "Když vám někdo navrhne dárek",
    email_confirm_invitation: "Pozvánky",
    email_confirm_invitation_desc: "Pozvánky do skupin a na události",
    email_confirm_reminder: "Připomenutí",
    email_confirm_reminder_desc: "Připomenutí blížících se událostí",
    push_notifications: "Push oznámení",
    push_notifications_desc: "Oznámení v prohlížeči a na mobilu",
    all_categories_on: "Zapnout vše",
    all_categories_off: "Vypnout vše",
    
    // Groups
    create_group: "Vytvořit skupinu",
    groups_coming_soon: "Skupiny již brzy",
    groups_coming_soon_desc: "Vytvořte skupiny s přáteli a rodinou pro koordinaci dárků.",
    back_to_dashboard: "Zpět na přehled",
    my_groups: "Moje skupiny",
    no_groups: "Zatím žádné skupiny",
    no_groups_desc: "Vytvořte skupinu pro koordinaci dárků",
    create_first_group: "Vytvořit první skupinu",
    members: "členů",
    invite_members: "Pozvat členy",
    create_group_desc: "Vytvořte skupinu pro koordinaci dárků",
    group_name: "Název skupiny",
    group_name_placeholder: "Např: Rodinné Vánoce",
    description: "Popis",
    group_desc_placeholder: "K čemu je tato skupina?",
    private_group: "Soukromá skupina",
    group_created: "Skupina vytvořena!",
    invitation_sent: "Pozvánka odeslána!",
    by_username: "Podle uživatelského jména",
    by_link: "Pomocí odkazu",
    search_username: "Hledat podle uživatele nebo ID",
    or_enter_code: "Nebo zadejte kód",
    invite: "Pozvat",
    share_link: "Sdílet odkaz",
    link_desc: "Kdokoli s tímto odkazem se může připojit",
    qr_desc: "Naskenujte pro připojení",
    owner: "Vlastník",
    leave_group: "Opustit skupinu",
    delete_group: "Smazat skupinu",
    left_group: "Opustili jste skupinu",
    group_deleted: "Skupina smazána",
    confirm_leave: "Opravdu chcete opustit tuto skupinu?",
    confirm_delete_group: "Opravdu chcete smazat tuto skupinu?",
    group_not_found: "Skupina nenalezena",
    decline: "Odmítnout",
    from: "od",
    view: "Zobrazit",
    events: "Události",
    chat: "Chat",
    secret_santa: "Tajný Santa",
    share_event: "Sdílet událost",
    share_event_desc: "Sdílejte svou událost s touto skupinou",
    no_shared_events: "Žádné sdílené události",
    no_events_to_share: "Nemáte události ke sdílení",
    all_events_shared: "Všechny vaše události jsou již sdíleny",
    event_shared: "Událost sdílena!",
    event_removed: "Událost odebrána ze skupiny",
    shared_by: "Sdílel/a",
    type_message: "Napište zprávu...",
    message: "Zpráva",
    no_messages: "Zatím žádné zprávy",
    connected: "Připojeno",
    connecting: "Připojování...",
    typing: "píše...",
    create_santa: "Vytvořit Tajného Santu",
    santa_desc: "Uspořádejte tajnou výměnu dárků",
    santa_setup_desc: "Nastavte rozpočet a datum",
    min_budget: "Minimální rozpočet",
    max_budget: "Maximální rozpočet",
    exchange_date: "Datum výměny",
    santa_message_placeholder: "Volitelná zpráva pro účastníky...",
    start_santa: "Zahájit losování",
    need_3_members: "Potřeba alespoň 3 členů",
    secret_santa_active: "Tajný Santa aktivní!",
    you_give_to: "Dáváte",
    reveal: "Odhalit",
    confirm_reveal: "Odhalit všechna přiřazení?",
    santa_revealed: "Tajný Santa odhalen!",
    santa_cancelled: "Tajný Santa zrušen",
    confirm_cancel_santa: "Zrušit Tajného Santu?",
    transfer_ownership: "Převést vlastnictví",
    select_new_owner: "Vybrat nového vlastníka",
    select_member: "Vybrat člena",
    transfer: "Převést",
    transfer_warning: "Tuto akci nelze vrátit",
    ownership_transferred: "Vlastnictví převedeno",
  },
  
  sk: {
    app_name: "Gift-Wish",
    reservation_time: "Čas rezervácie",
    free_for_all: "Zadarmo pre všetkých",
    login: "Prihlásiť sa",
    logout: "Odhlásiť sa",
    my_lists: "Moje zoznamy",
    back: "← Späť",
    save: "Uložiť",
    cancel: "Zrušiť",
    delete: "Zmazať",
    edit: "Upraviť",
    add: "Pridať",
    create: "Vytvoriť",
    share: "Zdieľať",
    copied: "Skopírované!",
    loading: "Načítava sa...",
    error: "Chyba",
    success: "Úspech",
    too_many_requests: "Príliš veľa pokusov. Skúste neskôr.",
    email_already_registered: "Tento email je už zaregistrovaný",
    invalid_credentials: "Neplatný email alebo heslo",
    password_too_short: "Heslo musí mať aspoň 6 znakov",
    
    hero_title: "Perfektné darčeky",
    hero_title_accent: "bez prekvapení",
    hero_description: "Vytvorte zoznam prianí a zdieľajte ho s priateľmi. Rezervujú darčeky — nikto nedá to isté.",
    create_list: "Vytvoriť zoznam",
    learn_more: "Zistiť viac",
    how_it_works: "Ako to funguje",
    simple_process: "Jednoduchý 4-krokový proces k perfektným darčekom",
    for_any_occasion: "Pre každú príležitosť",
    not_only_birthday: "Vytvárajte zoznamy nielen pre narodeniny",
    ready_to_create: "Pripravení vytvoriť svoj zoznam?",
    join_free: "Pridajte sa zadarmo a začnite dostávať perfektné darčeky",
    start_free: "Začať zadarmo",
    all_rights: "Všetky práva vyhradené.",
    privacy_policy: "Súkromie",
    terms_of_service: "Podmienky",
    contact: "Kontakt",
    
    feature_gifts: "Zoznamy darčekov",
    feature_gifts_desc: "Vytvárajte zoznamy pre akúkoľvek udalosť",
    feature_share: "Zdieľajte odkaz",
    feature_share_desc: "Pošlite priateľom alebo na sociálne siete",
    feature_reserve: "Rezervácia",
    feature_reserve_desc: "Priatelia rezervujú — žiadne duplikáty",
    feature_countdown: "Odpočet",
    feature_countdown_desc: "Sledujte dni do udalosti",
    
    hello: "Ahoj",
    manage_wishlists: "Spravujte svoje zoznamy prianí",
    create_event: "Vytvoriť udalosť",
    no_events: "Zatiaľ žiadne udalosti",
    create_first: "Vytvorte svoju prvú udalosť!",
    upcoming_events: "Nadchádzajúce udalosti",
    past_events: "Minulé udalosti",
    today: "Dnes!",
    days: "dní",
    
    new_event: "Nová udalosť",
    event_title: "Názov",
    event_title_placeholder: "Moje narodeniny 2026",
    event_type: "Typ udalosti",
    event_date: "Dátum udalosti",
    currency: "Mena",
    event_description: "Popis (voliteľné)",
    event_description_placeholder: "Ďalšie informácie...",
    public_list: "Verejný zoznam",
    
    event_birthday: "Narodeniny",
    event_wedding: "Svadba",
    event_new_year: "Nový rok",
    event_baby_shower: "Baby Shower",
    event_graduation: "Promócie",
    event_christmas: "Vianoce",
    event_anniversary: "Výročie",
    event_housewarming: "Kolaudácia",
    event_valentines: "Valentín",
    event_womens_day: "Medzinárodný deň žien",
    event_mothers_day: "Deň matiek",
    event_fathers_day: "Deň otcov",
    event_easter: "Veľká noc",
    event_halloween: "Halloween",
    event_thanksgiving: "Deň vďakyvzdania",
    event_engagement: "Zasnúbenie",
    event_retirement: "Dôchodok",
    event_promotion: "Povýšenie",
    event_other: "Iné",
    
    gifts: "Darčeky",
    add_gift: "Pridať darček",
    edit_gift: "Upraviť",
    gift_name: "Názov",
    gift_name_placeholder: "iPhone 15 Pro",
    gift_description: "Popis",
    gift_description_placeholder: "Farba, veľkosť atď.",
    gift_price: "Cena",
    gift_link: "Odkaz na produkt",
    gift_image: "Obrázok",
    auto_image_hint: "Alebo vložte odkaz na produkt — obrázok sa načíta automaticky",
    upload_image: "Nahrať obrázok",
    upload_hint: "JPG, PNG, GIF do 5 MB",
    drag_drop_hint: "Presuňte súbor sem alebo kliknite",
    drop_here: "Pustite pre nahranie",
    uploading: "Nahráva sa...",
    image_uploaded: "Obrázok nahraný",
    upload_error: "Chyba nahrávania",
    invalid_file_type: "Vyberte obrázok",
    file_too_large: "Maximum 5 MB",
    image_error: "Chyba načítania",
    gift_priority: "Priorita",
    priority_1: "Veľmi chcem",
    priority_2: "Chcem",
    priority_3: "Bolo by fajn",
    empty_list: "Zoznam je prázdny",
    add_first_gift: "Pridajte svoj prvý darček",
    reserved: "rezervované",
    reserved_by: "Rezervoval:",
    link: "Odkaz",
    events_count: "udalostí",
    search_events: "Hľadať udalosti...",
    search_users_placeholder: "Hľadať podľa mena alebo čísla...",
    no_users_found: "Žiadni používatelia nenájdení",
    search_hint: "Zadajte aspoň 2 znaky",
    days_left: "dní",
    past_event: "Minulá",
    today: "Dnes",
    archived: "Archivované",
    no_events: "Žiadne udalosti",
    create_first_event: "Vytvorte svoju prvú udalosť",
    
    // Archive
    archive: "Archív spomienok",
    save_as_memory: "Uložiť ako spomienku",
    archived_events: "Archivované udalosti",
    no_archived_events: "Žiadne archivované udalosti",
    restore_event: "Obnoviť",
    event_archived: "Udalosť archivovaná",
    event_restored: "Udalosť obnovená",
    
    // Crowdfunding
    crowdfunding: "Zbierka",
    enable_crowdfunding: "Povoliť zbierku",
    goal_amount: "Cieľová suma",
    collected: "Vybraté",
    contribute: "Prispieť",
    contribution_amount: "Výška príspevku",
    contribution_message: "Správa (voliteľné)",
    contribution_hint: "Zadajte sumu, ktorú chcete prispieť na tento darček",
    message_placeholder: "Všetko najlepšie!",
    contribution_success: "Príspevok pridaný!",
    contributors: "Prispievatelia",
    no_contributions: "Zatiaľ žiadne príspevky",
    crowdfunding_hint: "Priatelia môžu prispieť na tento darček",
    promised: "Sľúbené",
    view_contributions: "Príspevky",
    contributions_list: "Zoznam príspevkov",
    total: "Celkom",
    
    wishlist_from: "Zoznam prianí od",
    in_days: "Za",
    reserved_gifts: "Rezervované darčeky",
    of: "z",
    wishlist_not_found: "Zoznam nenájdený",
    wrong_link: "Odkaz môže byť nesprávny alebo je zoznam súkromný",
    
    reserve_gift: "Rezervovať darček",
    reserve_description: "Zadajte svoje meno, aby ostatní vedeli, že je tento darček rezervovaný",
    your_name: "Vaše meno",
    your_name_placeholder: "Ako sa voláte?",
    reserve: "Rezervovať",
    gift_reserved: "Darček rezervovaný!",
    
    affiliate_note: "Nákupom cez tento odkaz podporujete službu",
    buy_now: "Kúpiť",
    
    error_loading: "Chyba načítania",
    error_creating: "Chyba vytvárania",
    error_saving: "Chyba ukladania",
    error_deleting: "Chyba mazania",
    error_reserving: "Chyba rezervácie",
    error_auth: "Chyba autentifikácie",
    fill_required: "Vyplňte povinné polia",
    enter_name: "Zadajte svoje meno",
    enter_gift_name: "Zadajte názov darčeka",
    event_archived_message: "Táto udalosť skončila a bola archivovaná",
    event_no_longer_available: "Tento zoznam prianí už nie je dostupný",
    
    event_created: "Udalosť vytvorená!",
    event_updated: "Udalosť aktualizovaná",
    event_deleted: "Udalosť zmazaná",
    delete_event_title: "Zmazať udalosť?",
    delete_event_confirm: "Túto akciu nie je možné vrátiť späť. Všetky darčeky v tejto udalosti budú tiež zmazané.",
    edit_event: "Upraviť udalosť",
    enter_event_name: "Zadajte názov udalosti",
    gift_added: "Darček pridaný",
    gift_updated: "Darček aktualizovaný",
    gift_deleted: "Darček zmazaný",
    link_copied: "Odkaz skopírovaný!",
    
    
    // Admin
    admin_panel: "Administrácia",
    new_last_30_days: "Za posledných 30 dní",
    
    // Auth Modal
    welcome_back: "Vitajte späť",
    create_account: "Vytvoriť účet",
    login_subtitle: "Prihláste sa pre pokračovanie",
    register_subtitle: "Pripojte sa zadarmo",
    continue_google: "Pokračovať s Google",
    or: "alebo",
    name_placeholder: "Vaše meno",
    password: "Heslo",
    show_password: "Zobraziť heslo",
    hide_password: "Skryť heslo",
    sign_in: "Prihlásiť sa",
    sign_up: "Zaregistrovať sa",
    no_account: "Nemáte účet?",
    have_account: "Máte účet?",
    email_required: "Email je povinný",
    email_invalid: "Neplatný email",
    password_required: "Heslo je povinné",
    password_min: "Minimálne 6 znakov",
    name_required: "Meno je povinné",
    login_success: "Vitajte!",
    register_success: "Účet vytvorený!",
    remember_me: "Zapamätať si ma",
    forgot_password: "Zabudli ste heslo?",
    forgot_subtitle: "Zadajte email pre obnovenie",
    send_reset_link: "Odoslať odkaz",
    check_email: "Skontrolujte email",
    reset_email_sent: "Poslali sme odkaz pre reset hesla na",
    back_to_login: "Späť na prihlásenie",
    
    // Countdown
    countdown_days: "dní",
    countdown_hours: "hodín",
    countdown_minutes: "minút",
    countdown_seconds: "sekúnd",
    event_passed: "Udalosť prebehla",
    
    // Gift link
    gift_link_btn: "Odkaz na darček",
    show_gift: "Zobraziť darček",
    
    // Reservation
    expires: "Vyprší",
    reservation_expired: "Rezervácia vypršala",
    reservation_permanent: "Trvalá rezervácia",
    reservation_expires_in: "Vyprší za",
    show_more: "Zobraziť viac",
    show_less: "Zobraziť menej",
    bought: "Kúpené",
    mark_bought: "Kúpené",
    gift_bought: "Darček označený ako kúpený!",
    show_timer_label: "Zobraziť časovač rezervácie",
    show_timer_hint: "Priatelia uvidia zostávajúci čas",
    
    // Suggestions
    suggest_gift: "Navrhnúť darček",
    suggest_description: "Navrhnite nápad na darček pre tento zoznam",
    suggestion_sent: "Návrh odoslaný!",
    pending_suggestions: "Návrhy od priateľov",
    no_suggestions: "Žiadne nové návrhy",
    approve: "Pridať",
    reject: "Odmietnuť",
    suggestion_approved: "Návrh pridaný do zoznamu",
    suggestion_rejected: "Návrh odmietnutý",
    suggested_by: "Navrhol:",
    
    // Telegram
    telegram_desc: "Dostávajte upozornenia o rezerváciách a príspevkoch cez Telegram",
    telegram_connected: "Pripojené",
    telegram_notifications_desc: "Budete dostávať upozornenia o rezerváciách darčekov, príspevkoch do zbierky a návrhoch od priateľov.",
    telegram_link_desc: "Kliknite na tlačidlo nižšie pre otvorenie bota a prepojenie účtu:",
    telegram_code_expires: "Kód platí 10 minút",
    telegram_unlinked: "Telegram odpojený",
    open_telegram: "Otvoriť Telegram",
    disconnect: "Odpojiť",
    
    // PWA
    install_app: "Nainštalovať aplikáciu",
    install_app_desc: "Pridajte Gift-Wish na domovskú obrazovku pre rýchly prístup",
    install: "Nainštalovať",
    not_now: "Teraz nie",
    
    // Password reset
    reset_password: "Obnoviť heslo",
    new_password: "Nové heslo",
    confirm_password: "Potvrdiť heslo",
    password_reset_success: "Heslo úspešne obnovené!",
    invalid_token: "Neplatný alebo expirovaný token",
    
    // Admin panel
    admin_dashboard: "Prehľad",
    admin_users: "Používatelia",
    admin_events: "Udalosti",
    admin_clicks: "Affiliate kliky",
    admin_export: "Exportovať dáta",
    search: "Hľadať...",
    actions: "Akcie",
    ban: "Zablokovať",
    unban: "Odblokovať",
    banned: "Zablokovaný",
    confirm_ban: "Naozaj chcete zablokovať tohto používateľa?",
    confirm_delete: "Naozaj chcete zmazať?",
    user_banned: "Používateľ zablokovaný",
    user_unbanned: "Používateľ odblokovaný",
    user_deleted: "Používateľ zmazaný",
    export_csv: "Exportovať CSV",
    no_data: "Žiadne dáta",
    total_users: "Celkom používateľov",
    total_events: "Celkom udalostí",
    total_gifts: "Celkom darčekov",
    total_reservations: "Celkom rezervácií",
    total_clicks: "Celkom klikov",
    daily_activity: "Denná aktivita",
    top_products: "Top produkty",
    clicks_by_type: "Kliky podľa typu",
    clicks: "Kliky",
    
    // Affiliate
    amazon: "Amazon",
    aliexpress: "AliExpress",
    ebay: "eBay",
    other: "Ostatné",
    short_amazon_warning: "Krátke odkazy Amazon môžu stratiť sledovanie. Použite úplnú URL.",
    link_resolved: "Odkaz vyriešený",
    
    // Navigation Sidebar
    nav_overview: "Prehľad",
    nav_my_lists: "Moje zoznamy",
    nav_groups: "Skupiny",
    nav_invitations: "Pozvánky",
    nav_settings: "Nastavenia",
    sign_out: "Odhlásiť sa",
    hide_menu: "Skryť menu",
    show_menu: "Zobraziť menu",
    your_code: "Váš kód",
    code_copied: "Kód skopírovaný!",
    pending_invitations: "Čakajúce",
    no_pending_invitations: "Žiadne čakajúce pozvánky",
    invited_by: "Pozval",
    invitation_accepted: "Pozvánka prijatá!",
    invitation_declined: "Pozvánka odmietnutá",
    invitation_history: "História",
    accepted: "Prijaté",
    declined: "Odmietnuté",
    accept: "Prijať",
    settings_saved: "Nastavenia uložené",
    language_region: "Jazyk a región",
    language_region_desc: "Vyberte preferovaný jazyk a región",
    notifications: "Oznámenia",
    notifications_desc: "Spravujte spôsob prijímania oznámení",
    email_event_reminders: "Pripomienky udalostí",
    email_event_reminders_desc: "Dostávať pripomienky pred udalosťami",
    email_gift_updates: "Aktualizácie darčekov",
    email_gift_updates_desc: "Keď sú darčeky rezervované alebo zakúpené",
    email_invitations: "Oznámenia o pozvánkach",
    email_invitations_desc: "Keď vás niekto pozve na udalosť",
    privacy: "Súkromie",
    privacy_desc: "Ovládajte nastavenia súkromia",
    public_profile: "Verejný profil",
    public_profile_desc: "Ostatní môžu vidieť váš profil",
    show_wishlists: "Zobraziť zoznamy želaní",
    show_wishlists_desc: "Zobraziť zoznamy na vašom profile",
    account: "Účet",
    help_support: "Pomoc a podpora",
    coming_soon: "Už čoskoro",
    logged_out: "Boli ste odhlásení",
    premium: "Premium",
    trusted_by: "Tisíce nám",
    happy_users: "dôverujú",
    no_duplicates: "Bez duplicít",
    smart_reservation: "Inteligentná rezervácia",
    open_list: "Otvoriť zoznam",
    search_placeholder: "Hľadať priateľov alebo udalosti...",
    invitations: "Pozvánky",
    my_events_section: "Moje udalosti",
    see_all: "VŠETKO",
    view_gifts: "Zobraziť darčeky",
    gifts_progress: "darčekov",
    no_invitations: "Žiadne pozvánky",
    event_from: "od",
    
    // Notification settings
    notification_categories: "Podľa kategórií udalostí",
    notification_categories_desc: "Vyberte, pre ktoré udalosti dostávať emaily",
    notification_confirmations: "E-mailové potvrdenia",
    notification_confirmations_desc: "Oznámenia o akciách s vašimi darčekmi",
    email_confirm_reservation: "Rezervácie darčekov",
    email_confirm_reservation_desc: "Keď niekto rezervuje váš darček",
    email_confirm_contribution: "Príspevky do zbierky",
    email_confirm_contribution_desc: "Keď niekto prispeje na váš darček",
    email_confirm_suggestion: "Návrhy darčekov",
    email_confirm_suggestion_desc: "Keď vám niekto navrhne darček",
    email_confirm_invitation: "Pozvánky",
    email_confirm_invitation_desc: "Pozvánky do skupín a na udalosti",
    email_confirm_reminder: "Pripomienky",
    email_confirm_reminder_desc: "Pripomienky blížiacich sa udalostí",
    push_notifications: "Push oznámenia",
    push_notifications_desc: "Oznámenia v prehliadači a na mobile",
    all_categories_on: "Zapnúť všetko",
    all_categories_off: "Vypnúť všetko",
    
    // Groups
    create_group: "Vytvoriť skupinu",
    groups_coming_soon: "Skupiny už čoskoro",
    groups_coming_soon_desc: "Vytvorte skupiny s priateľmi a rodinou pre koordináciu darčekov.",
    back_to_dashboard: "Späť na prehľad",
    my_groups: "Moje skupiny",
    no_groups: "Zatiaľ žiadne skupiny",
    no_groups_desc: "Vytvorte skupinu pre koordináciu darčekov",
    create_first_group: "Vytvoriť prvú skupinu",
    members: "členov",
    invite_members: "Pozvať členov",
    create_group_desc: "Vytvorte skupinu pre koordináciu darčekov",
    group_name: "Názov skupiny",
    group_name_placeholder: "Napr: Rodinné Vianoce",
    description: "Popis",
    group_desc_placeholder: "Na čo je táto skupina?",
    private_group: "Súkromná skupina",
    group_created: "Skupina vytvorená!",
    invitation_sent: "Pozvánka odoslaná!",
    by_username: "Podľa používateľského mena",
    by_link: "Pomocou odkazu",
    search_username: "Hľadať podľa používateľa alebo ID",
    or_enter_code: "Alebo zadajte kód",
    invite: "Pozvať",
    share_link: "Zdieľať odkaz",
    link_desc: "Ktokoľvek s týmto odkazom sa môže pripojiť",
    qr_desc: "Naskenujte pre pripojenie",
    owner: "Vlastník",
    leave_group: "Opustiť skupinu",
    delete_group: "Zmazať skupinu",
    left_group: "Opustili ste skupinu",
    group_deleted: "Skupina zmazaná",
    confirm_leave: "Naozaj chcete opustiť túto skupinu?",
    confirm_delete_group: "Naozaj chcete zmazať túto skupinu?",
    group_not_found: "Skupina nenájdená",
    decline: "Odmietnuť",
    from: "od",
    view: "Zobraziť",
    events: "Udalosti",
    chat: "Chat",
    secret_santa: "Tajný Santa",
    share_event: "Zdieľať udalosť",
    share_event_desc: "Zdieľajte svoju udalosť s touto skupinou",
    no_shared_events: "Žiadne zdieľané udalosti",
    no_events_to_share: "Nemáte udalosti na zdieľanie",
    all_events_shared: "Všetky vaše udalosti sú už zdieľané",
    event_shared: "Udalosť zdieľaná!",
    event_removed: "Udalosť odstránená zo skupiny",
    shared_by: "Zdieľal/a",
    type_message: "Napíšte správu...",
    message: "Správa",
    no_messages: "Zatiaľ žiadne správy",
    connected: "Pripojené",
    connecting: "Pripájanie...",
    typing: "píše...",
    create_santa: "Vytvoriť Tajného Santu",
    santa_desc: "Usporiadajte tajnú výmenu darčekov",
    santa_setup_desc: "Nastavte rozpočet a dátum",
    min_budget: "Minimálny rozpočet",
    max_budget: "Maximálny rozpočet",
    exchange_date: "Dátum výmeny",
    santa_message_placeholder: "Voliteľná správa pre účastníkov...",
    start_santa: "Začať žrebovanie",
    need_3_members: "Potrebných minimálne 3 členov",
    secret_santa_active: "Tajný Santa aktívny!",
    you_give_to: "Dávate",
    reveal: "Odhaliť",
    confirm_reveal: "Odhaliť všetky priradenia?",
    santa_revealed: "Tajný Santa odhalený!",
    santa_cancelled: "Tajný Santa zrušený",
    confirm_cancel_santa: "Zrušiť Tajného Santu?",
    transfer_ownership: "Previesť vlastníctvo",
    select_new_owner: "Vybrať nového vlastníka",
    select_member: "Vybrať člena",
    transfer: "Previesť",
    transfer_warning: "Túto akciu nie je možné vrátiť",
    ownership_transferred: "Vlastníctvo prevedené",
  },
  
  uk: {
    // General
    app_name: "Gift-Wish",
    reservation_time: "Час бронювання",
    free_for_all: "Безкоштовно для всіх",
    login: "Увійти",
    logout: "Вийти",
    my_lists: "Мої списки",
    back: "← Назад",
    save: "Зберегти",
    cancel: "Скасувати",
    delete: "Видалити",
    edit: "Редагувати",
    add: "Додати",
    create: "Створити",
    share: "Поділитися",
    copied: "Скопійовано!",
    loading: "Завантаження...",
    error: "Помилка",
    success: "Успішно",
    too_many_requests: "Забагато спроб. Спробуйте пізніше.",
    email_already_registered: "Ця електронна адреса вже зареєстрована",
    invalid_credentials: "Невірна електронна адреса або пароль",
    password_too_short: "Пароль має містити щонайменше 6 символів",
    
    // Landing
    hero_title: "Ідеальні подарунки",
    hero_title_accent: "без сюрпризів",
    hero_description: "Створіть список бажаних подарунків і поділіться ним з друзями. Вони заброньюють подарунки — і ніхто не подарує одне й те саме.",
    create_list: "Створити список",
    learn_more: "Дізнатися більше",
    how_it_works: "Як це працює",
    simple_process: "Простий процес з 4 кроків до ідеальних подарунків",
    for_any_occasion: "Для будь-якої події",
    not_only_birthday: "Створюйте списки не лише для дня народження",
    ready_to_create: "Готові створити свій список?",
    join_free: "Приєднуйтесь безкоштовно і почніть отримувати ідеальні подарунки",
    start_free: "Створити список",
    all_rights: "Усі права захищені.",
    privacy_policy: "Конфіденційність",
    terms_of_service: "Умови",
    contact: "Контакти",
    
    // Features
    feature_gifts: "Списки подарунків",
    feature_gifts_desc: "Створюйте списки для будь-яких подій",
    feature_share: "Діліться посиланням",
    feature_share_desc: "Надсилайте друзям або в соцмережі",
    feature_reserve: "Бронювання",
    feature_reserve_desc: "Друзі бронюють — без дублікатів",
    feature_countdown: "Зворотний відлік",
    feature_countdown_desc: "Слідкуйте за днями до події",
    
    // Dashboard
    hello: "Привіт",
    manage_wishlists: "Керуйте своїми списками бажань",
    create_event: "Створити подію",
    no_events: "Поки що немає подій",
    create_first: "Створіть свою першу подію!",
    upcoming_events: "Майбутні події",
    past_events: "Минулі події",
    today: "Сьогодні!",
    days: "днів",
    
    // Event
    new_event: "Нова подія",
    event_title: "Назва",
    event_title_placeholder: "Мій день народження 2026",
    event_type: "Тип події",
    event_date: "Дата події",
    currency: "Валюта",
    event_description: "Опис (необов'язково)",
    event_description_placeholder: "Додаткова інформація...",
    public_list: "Публічний список",
    
    // Event types
    event_birthday: "День народження",
    event_wedding: "Весілля",
    event_new_year: "Новий рік",
    event_baby_shower: "Baby Shower",
    event_graduation: "Випускний",
    event_christmas: "Різдво",
    event_anniversary: "Річниця",
    event_housewarming: "Новосілля",
    event_valentines: "День Валентина",
    event_womens_day: "8 Березня",
    event_mothers_day: "День матері",
    event_fathers_day: "День батька",
    event_easter: "Великдень",
    event_halloween: "Гелловін",
    event_thanksgiving: "День подяки",
    event_engagement: "Заручини",
    event_retirement: "Вихід на пенсію",
    event_promotion: "Підвищення",
    event_other: "Інше",
    
    // Gifts
    gifts: "Подарунки",
    add_gift: "Додати подарунок",
    edit_gift: "Редагувати",
    gift_name: "Назва",
    gift_name_placeholder: "iPhone 15 Pro",
    gift_description: "Опис",
    gift_description_placeholder: "Колір, розмір тощо.",
    gift_price: "Ціна",
    gift_link: "Посилання на товар",
    gift_image: "Зображення",
    auto_image_hint: "Або вставте посилання на товар — зображення завантажиться автоматично",
    upload_image: "Завантажити зображення",
    upload_hint: "JPG, PNG, GIF до 5 МБ",
    drag_drop_hint: "Перетягніть файл сюди або клікніть",
    drop_here: "Відпустіть для завантаження",
    uploading: "Завантаження...",
    image_uploaded: "Зображення завантажено",
    upload_error: "Помилка завантаження",
    invalid_file_type: "Виберіть зображення",
    file_too_large: "Максимум 5 МБ",
    image_error: "Помилка завантаження",
    gift_priority: "Пріоритет",
    priority_1: "Дуже хочу",
    priority_2: "Хочу",
    priority_3: "Було б непогано",
    empty_list: "Список порожній",
    add_first_gift: "Додайте свій перший подарунок",
    reserved: "заброньовано",
    reserved_by: "Забронював:",
    link: "Посилання",
    events_count: "подій",
    search_events: "Пошук подій...",
    search_users_placeholder: "Пошук за нікнеймом або номером...",
    no_users_found: "Користувачів не знайдено",
    search_hint: "Введіть мінімум 2 символи",
    days_left: "днів",
    past_event: "Минула",
    today: "Сьогодні",
    archived: "Архів",
    no_events: "Немає подій",
    create_first_event: "Створіть свою першу подію",
    
    // Archive
    archive: "Архів спогадів",
    save_as_memory: "Зберегти як спогад",
    archived_events: "Архівовані події",
    no_archived_events: "Немає архівованих подій",
    restore_event: "Відновити",
    event_archived: "Подію архівовано",
    event_restored: "Подію відновлено",
    
    // Crowdfunding
    crowdfunding: "Збір коштів",
    enable_crowdfunding: "Увімкнути збір коштів",
    goal_amount: "Цільова сума",
    collected: "Зібрано",
    contribute: "Внести",
    contribution_amount: "Сума внеску",
    contribution_message: "Повідомлення (необов'язково)",
    contribution_hint: "Вкажіть суму, яку ви готові внести на цей подарунок",
    message_placeholder: "З днем народження!",
    contribution_success: "Внесок додано!",
    contributors: "Учасники",
    no_contributions: "Поки що немає внесків",
    crowdfunding_hint: "Друзі можуть скинутися на цей подарунок",
    promised: "Обіцяно",
    view_contributions: "Внески",
    contributions_list: "Список внесків",
    total: "Усього",
    
    // Public wishlist
    wishlist_from: "Список бажань від",
    in_days: "Через",
    reserved_gifts: "Заброньовано подарунків",
    of: "з",
    wishlist_not_found: "Список не знайдено",
    wrong_link: "Посилання може бути неправильним або список приватний",
    
    // Reservation
    reserve_gift: "Забронювати подарунок",
    reserve_description: "Введіть своє ім'я, щоб інші знали, що цей подарунок заброньовано",
    your_name: "Ваше ім'я",
    your_name_placeholder: "Як вас звати?",
    reserve: "Забронювати",
    gift_reserved: "Подарунок заброньовано!",
    
    // Affiliate
    affiliate_note: "Купуючи за цим посиланням, ви підтримуєте сервіс",
    buy_now: "Купити",
    
    // Errors
    error_loading: "Помилка завантаження",
    error_creating: "Помилка створення",
    error_saving: "Помилка збереження",
    error_deleting: "Помилка видалення",
    error_reserving: "Помилка бронювання",
    error_auth: "Помилка авторизації",
    fill_required: "Заповніть обов'язкові поля",
    enter_name: "Введіть своє ім'я",
    enter_gift_name: "Введіть назву подарунка",
    short_amazon_warning: "Короткі посилання Amazon можуть не працювати з affiliate. Рекомендуємо використовувати повне посилання.",
    link_resolved: "Посилання перетворено у повний формат",
    amazon: "Amazon",
    aliexpress: "AliExpress",
    ebay: "eBay",
    other: "Інше",
    event_archived_message: "Ця подія завершилась і була архівована",
    event_no_longer_available: "Цей список бажань більше недоступний",
    
    // Success messages
    event_created: "Подію створено!",
    event_updated: "Подію оновлено",
    event_deleted: "Подію видалено",
    delete_event_title: "Видалити подію?",
    delete_event_confirm: "Цю дію неможливо скасувати. Усі подарунки в цій події також будуть видалені.",
    edit_event: "Редагувати подію",
    enter_event_name: "Введіть назву події",
    gift_added: "Подарунок додано",
    gift_updated: "Подарунок оновлено",
    gift_deleted: "Подарунок видалено",
    link_copied: "Посилання скопійовано!",
    
    
    // Admin
    admin_panel: "Адміністрування",
    new_last_30_days: "За останні 30 днів",
    
    // Auth Modal
    welcome_back: "З поверненням",
    create_account: "Створити акаунт",
    login_subtitle: "Увійдіть для продовження",
    register_subtitle: "Приєднуйтесь безкоштовно",
    continue_google: "Продовжити з Google",
    or: "або",
    name_placeholder: "Ваше ім'я",
    password: "Пароль",
    show_password: "Показати пароль",
    hide_password: "Приховати пароль",
    sign_in: "Увійти",
    sign_up: "Зареєструватися",
    no_account: "Немає акаунта?",
    have_account: "Є акаунт?",
    email_required: "Email обов'язковий",
    email_invalid: "Невірний email",
    password_required: "Пароль обов'язковий",
    password_min: "Мінімум 6 символів",
    name_required: "Ім'я обов'язкове",
    login_success: "Ласкаво просимо!",
    register_success: "Акаунт створено!",
    remember_me: "Запам'ятати мене",
    forgot_password: "Забули пароль?",
    forgot_subtitle: "Введіть email для відновлення",
    send_reset_link: "Надіслати посилання",
    check_email: "Перевірте пошту",
    reset_email_sent: "Ми надіслали посилання для скидання пароля на",
    back_to_login: "Повернутися до входу",
    
    // Countdown
    countdown_days: "днів",
    countdown_hours: "годин",
    countdown_minutes: "хвилин",
    countdown_seconds: "секунд",
    event_passed: "Подія відбулася",
    
    // Gift link
    gift_link_btn: "Посилання на подарунок",
    show_gift: "Показати подарунок",
    
    // Reservation expiry
    expires: "Закінчується",
    reservation_expired: "Бронювання закінчилось",
    reservation_permanent: "Безстрокове бронювання",
    reservation_expires_in: "Закінчиться через",
    show_more: "Показати більше",
    show_less: "Згорнути",
    show_timer_label: "Показувати таймер бронювання",
    show_timer_hint: "Друзі побачать залишковий час",
    bought: "Куплено",
    mark_bought: "Куплено",
    gift_bought: "Подарунок позначено як куплений!",
    
    // Suggestions
    suggest_gift: "Запропонувати подарунок",
    suggest_description: "Запропонуйте ідею подарунка для цього списку",
    suggestion_sent: "Пропозицію надіслано!",
    pending_suggestions: "Пропозиції від друзів",
    no_suggestions: "Немає нових пропозицій",
    approve: "Додати",
    reject: "Відхилити",
    suggestion_approved: "Пропозицію додано до списку",
    suggestion_rejected: "Пропозицію відхилено",
    suggested_by: "Запропонував:",
    
    // Telegram
    telegram_desc: "Отримуйте сповіщення про бронювання та внески через Telegram",
    telegram_connected: "Підключено",
    telegram_notifications_desc: "Ви будете отримувати сповіщення про бронювання подарунків, внески до збору коштів та пропозиції від друзів.",
    telegram_link_desc: "Натисніть кнопку нижче, щоб відкрити бота і з'єднати акаунт:",
    telegram_code_expires: "Код дійсний 10 хвилин",
    telegram_unlinked: "Telegram від'єднано",
    open_telegram: "Відкрити Telegram",
    disconnect: "Від'єднати",
    
    // PWA
    install_app: "Встановити додаток",
    install_app_desc: "Додайте Gift-Wish на головний екран для швидкого доступу",
    install: "Встановити",
    not_now: "Не зараз",
    
    // Password reset
    reset_password: "Скинути пароль",
    new_password: "Новий пароль",
    confirm_password: "Підтвердити пароль",
    password_reset_success: "Пароль успішно скинуто!",
    invalid_token: "Недійсний або прострочений токен",
    
    // Admin panel
    admin_dashboard: "Панель",
    admin_users: "Користувачі",
    admin_events: "Події",
    admin_clicks: "Affiliate кліки",
    admin_export: "Експорт даних",
    search: "Пошук...",
    actions: "Дії",
    ban: "Заблокувати",
    unban: "Розблокувати",
    banned: "Заблокований",
    confirm_ban: "Ви впевнені, що хочете заблокувати цього користувача?",
    confirm_delete: "Ви впевнені, що хочете видалити?",
    user_banned: "Користувача заблоковано",
    user_unbanned: "Користувача розблоковано",
    user_deleted: "Користувача видалено",
    export_csv: "Експорт CSV",
    no_data: "Немає даних",
    total_users: "Всього користувачів",
    total_events: "Всього подій",
    total_gifts: "Всього подарунків",
    total_reservations: "Всього бронювань",
    total_clicks: "Всього кліків",
    daily_activity: "Щоденна активність",
    top_products: "Топ продукти",
    clicks_by_type: "Кліки за типом",
    clicks: "Кліки",
    
    // Navigation Sidebar
    nav_overview: "Огляд",
    nav_my_lists: "Мої списки",
    nav_groups: "Групи",
    nav_invitations: "Запрошення",
    nav_settings: "Налаштування",
    sign_out: "Вийти",
    hide_menu: "Приховати меню",
    show_menu: "Показати меню",
    your_code: "Ваш код",
    code_copied: "Код скопійовано!",
    pending_invitations: "Очікують",
    no_pending_invitations: "Немає очікуючих запрошень",
    invited_by: "Запросив",
    invitation_accepted: "Запрошення прийнято!",
    invitation_declined: "Запрошення відхилено",
    invitation_history: "Історія",
    accepted: "Прийнято",
    declined: "Відхилено",
    accept: "Прийняти",
    settings_saved: "Налаштування збережено",
    language_region: "Мова та регіон",
    language_region_desc: "Виберіть бажану мову та регіон",
    notifications: "Сповіщення",
    notifications_desc: "Керуйте способом отримання сповіщень",
    email_event_reminders: "Нагадування про події",
    email_event_reminders_desc: "Отримувати нагадування перед подіями",
    email_gift_updates: "Оновлення подарунків",
    email_gift_updates_desc: "Коли подарунки заброньовані або куплені",
    email_invitations: "Сповіщення про запрошення",
    email_invitations_desc: "Коли вас запрошують на подію",
    privacy: "Конфіденційність",
    privacy_desc: "Контролюйте налаштування конфіденційності",
    public_profile: "Публічний профіль",
    public_profile_desc: "Інші можуть бачити ваш профіль",
    show_wishlists: "Показувати списки бажань",
    show_wishlists_desc: "Відображати списки на вашому профілі",
    account: "Акаунт",
    help_support: "Допомога та підтримка",
    coming_soon: "Незабаром",
    logged_out: "Ви вийшли з акаунту",
    premium: "Преміум",
    trusted_by: "Нам довіряють",
    happy_users: "тисячі користувачів",
    no_duplicates: "Без дублікатів",
    smart_reservation: "Розумне бронювання",
    open_list: "Відкрити список",
    search_placeholder: "Шукати друзів або події...",
    invitations: "Запрошення",
    my_events_section: "Мої події",
    see_all: "ВСІ",
    view_gifts: "Переглянути подарунки",
    gifts_progress: "подарунків",
    no_invitations: "Немає запрошень",
    event_from: "від",
    
    // Notification settings
    notification_categories: "За категоріями подій",
    notification_categories_desc: "Виберіть, для яких подій отримувати листи",
    notification_confirmations: "Email-підтвердження",
    notification_confirmations_desc: "Сповіщення про дії з вашими подарунками",
    email_confirm_reservation: "Бронювання подарунків",
    email_confirm_reservation_desc: "Коли хтось бронює ваш подарунок",
    email_confirm_contribution: "Внески до збору",
    email_confirm_contribution_desc: "Коли хтось робить внесок до вашого подарунка",
    email_confirm_suggestion: "Пропозиції подарунків",
    email_confirm_suggestion_desc: "Коли хтось пропонує вам подарунок",
    email_confirm_invitation: "Запрошення",
    email_confirm_invitation_desc: "Запрошення до груп та на події",
    email_confirm_reminder: "Нагадування",
    email_confirm_reminder_desc: "Нагадування про наближення подій",
    push_notifications: "Push-сповіщення",
    push_notifications_desc: "Сповіщення в браузері та на телефоні",
    all_categories_on: "Увімкнути все",
    all_categories_off: "Вимкнути все",
    
    // Groups
    create_group: "Створити групу",
    groups_coming_soon: "Групи незабаром",
    groups_coming_soon_desc: "Створюйте групи з друзями та родиною для координації подарунків.",
    back_to_dashboard: "Повернутися до огляду",
    my_groups: "Мої групи",
    no_groups: "Поки немає груп",
    no_groups_desc: "Створіть групу для координації подарунків",
    create_first_group: "Створити першу групу",
    members: "учасників",
    invite_members: "Запросити учасників",
    create_group_desc: "Створіть групу для координації подарунків",
    group_name: "Назва групи",
    group_name_placeholder: "Напр: Сімейне Різдво",
    description: "Опис",
    group_desc_placeholder: "Для чого ця група?",
    private_group: "Приватна група",
    group_created: "Групу створено!",
    invitation_sent: "Запрошення надіслано!",
    by_username: "За іменем користувача",
    by_link: "За посиланням",
    search_username: "Шукати за користувачем або ID",
    or_enter_code: "Або введіть код",
    invite: "Запросити",
    share_link: "Поділитися посиланням",
    link_desc: "Будь-хто з цим посиланням може приєднатися",
    qr_desc: "Скануйте для приєднання",
    owner: "Власник",
    leave_group: "Покинути групу",
    delete_group: "Видалити групу",
    left_group: "Ви покинули групу",
    group_deleted: "Групу видалено",
    confirm_leave: "Ви впевнені, що хочете покинути цю групу?",
    confirm_delete_group: "Ви впевнені, що хочете видалити цю групу?",
    group_not_found: "Групу не знайдено",
    decline: "Відхилити",
    from: "від",
    view: "Переглянути",
    events: "Події",
    chat: "Чат",
    secret_santa: "Таємний Санта",
    share_event: "Поділитися подією",
    share_event_desc: "Поділіться своєю подією з цією групою",
    no_shared_events: "Немає спільних подій",
    no_events_to_share: "У вас немає подій для поширення",
    all_events_shared: "Всі ваші події вже поширені",
    event_shared: "Подію поширено!",
    event_removed: "Подію видалено з групи",
    shared_by: "Поширив/ла",
    type_message: "Напишіть повідомлення...",
    message: "Повідомлення",
    no_messages: "Поки немає повідомлень",
    connected: "Підключено",
    connecting: "Підключення...",
    typing: "пише...",
    create_santa: "Створити Таємного Санту",
    santa_desc: "Організуйте таємний обмін подарунками",
    santa_setup_desc: "Встановіть бюджет та дату",
    min_budget: "Мінімальний бюджет",
    max_budget: "Максимальний бюджет",
    exchange_date: "Дата обміну",
    santa_message_placeholder: "Необов'язкове повідомлення для учасників...",
    start_santa: "Почати жеребкування",
    need_3_members: "Потрібно мінімум 3 учасники",
    secret_santa_active: "Таємний Санта активний!",
    you_give_to: "Ви даруєте",
    reveal: "Розкрити",
    confirm_reveal: "Розкрити всі призначення?",
    santa_revealed: "Таємного Санту розкрито!",
    santa_cancelled: "Таємного Санту скасовано",
    confirm_cancel_santa: "Скасувати Таємного Санту?",
    transfer_ownership: "Передати власність",
    select_new_owner: "Вибрати нового власника",
    select_member: "Вибрати учасника",
    transfer: "Передати",
    transfer_warning: "Цю дію не можна скасувати",
    ownership_transferred: "Власність передано",
  },
};

// Language names for display
export const languageNames = {
  ru: { name: "Русский", flag: "🇷🇺" },
  uk: { name: "Українська", flag: "🇺🇦" },
  en: { name: "English", flag: "🇬🇧" },
  es: { name: "Español", flag: "🇪🇸" },
  fr: { name: "Français", flag: "🇫🇷" },
  de: { name: "Deutsch", flag: "🇩🇪" },
  cs: { name: "Čeština", flag: "🇨🇿" },
  sk: { name: "Slovenčina", flag: "🇸🇰" },
};

// Currency symbols by language (default)
export const currencySymbols = {
  ru: "₽",
  uk: "₴",
  en: "$",
  es: "€",
  fr: "€",
  de: "€",
  cs: "Kč",
  sk: "€",
};

// All available currencies
export const availableCurrencies = [
  { code: "RUB", symbol: "₽", name: "Рубль" },
  { code: "UAH", symbol: "₴", name: "Гривня" },
  { code: "USD", symbol: "$", name: "Dollar" },
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "GBP", symbol: "£", name: "Pound" },
  { code: "CZK", symbol: "Kč", name: "Koruna" },
];

// Date formatters by language
export const dateLocales = {
  ru: "ru-RU",
  uk: "uk-UA",
  en: "en-US",
  es: "es-ES",
  fr: "fr-FR",
  de: "de-DE",
  cs: "cs-CZ",
  sk: "sk-SK",
};

// Event types with emojis
export const eventTypes = [
  { type: "birthday", emoji: "🎂" },
  { type: "wedding", emoji: "💒" },
  { type: "new_year", emoji: "🎄" },
  { type: "christmas", emoji: "🎅" },
  { type: "baby_shower", emoji: "👶" },
  { type: "graduation", emoji: "🎓" },
  { type: "anniversary", emoji: "💑" },
  { type: "housewarming", emoji: "🏠" },
  { type: "valentines", emoji: "💝" },
  { type: "womens_day", emoji: "💐" },
  { type: "mothers_day", emoji: "👩" },
  { type: "fathers_day", emoji: "👨" },
  { type: "easter", emoji: "🐣" },
  { type: "halloween", emoji: "🎃" },
  { type: "thanksgiving", emoji: "🦃" },
  { type: "engagement", emoji: "💍" },
  { type: "retirement", emoji: "🎊" },
  { type: "promotion", emoji: "🏆" },
  { type: "other", emoji: "🎉" },
];

// Get browser language
export const getBrowserLanguage = () => {
  const browserLang = navigator.language.split("-")[0];
  return translations[browserLang] ? browserLang : "en";
};
